module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 29);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = require("tslib");

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(1);

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(2), exports);
tslib_1.__exportStar(__webpack_require__(3), exports);
tslib_1.__exportStar(__webpack_require__(4), exports);
tslib_1.__exportStar(__webpack_require__(5), exports);
tslib_1.__exportStar(__webpack_require__(6), exports);
tslib_1.__exportStar(__webpack_require__(7), exports);
tslib_1.__exportStar(__webpack_require__(8), exports);
tslib_1.__exportStar(__webpack_require__(9), exports);
tslib_1.__exportStar(__webpack_require__(10), exports);
tslib_1.__exportStar(__webpack_require__(11), exports);
tslib_1.__exportStar(__webpack_require__(12), exports);


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var defaultCookieOptions = {
    domain: '.cian.ru',
    path: '/',
    secure: true,
};
exports.setCookie = function (name, value, config) {
    var options = Object.assign({}, defaultCookieOptions, config);
    var expires = options.expires;
    var cookieExpires;
    if (expires) {
        if (typeof expires === 'number') {
            var d = new Date();
            cookieExpires = new Date(d.setTime(d.getTime() + expires * 1000)).toUTCString();
        }
        else if (expires instanceof Date) {
            cookieExpires = expires.toUTCString();
        }
    }
    document.cookie =
        // tslint:disable-next-line:prefer-template
        name + "=" + encodeURIComponent(value) + "; " +
            ("path=" + options.path) +
            ("; domain=" + options.domain) +
            (cookieExpires ? "; expires=" + cookieExpires : '') +
            (options.secure ? "; secure" : '');
};
exports.deleteCookie = function (name, config) {
    exports.setCookie(name, '', Object.assign({}, config, {
        expires: -1,
    }));
};


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var hostPatterns = [
    ['beta', /stage\.cian\.ru$/i],
    ['development', /dev[2,3]?\.cian\.ru$/i],
    ['local', /local(\.map)?\.cian\.ru$/i],
    ['local', /^localhost(:\d+)?$/i],
    ['production', /cian\.ru$/i],
];
function calculateEnvironmentByHost(host) {
    for (var _i = 0, hostPatterns_1 = hostPatterns; _i < hostPatterns_1.length; _i++) {
        var hostPattern = hostPatterns_1[_i];
        if (hostPattern[1].test(host)) {
            return hostPattern[0];
        }
    }
    return 'unknown';
}
exports.calculateEnvironmentByHost = calculateEnvironmentByHost;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.parseCookies = function (cookiesString) {
    var cookiesObject = {};
    var pairs = cookiesString.split(/; */);
    for (var i = 0; i < pairs.length; i++) {
        var pair = pairs[i];
        var eqIdx = pair.indexOf('=');
        // skip things that don't look like key=value
        if (eqIdx < 0) {
            continue;
        }
        var key = pair.substr(0, eqIdx).trim();
        // tslint:disable-next-line:restrict-plus-operands
        var value = pair.substr(eqIdx + 1, pair.length).trim();
        // quoted values
        if (value[0] === '"') {
            value = value.slice(1, -1);
        }
        // only assign once
        if (!(key in cookiesObject)) {
            cookiesObject[key] = decodeURIComponent(value);
        }
    }
    return cookiesObject;
};


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var monthNames = [
    'января',
    'февраля',
    'марта',
    'апреля',
    'мая',
    'июня',
    'июля',
    'августа',
    'сентября',
    'октября',
    'ноября',
    'декабря',
];
function isValidDate(date) {
    return !isNaN(date.getTime());
}
exports.isValidDate = isValidDate;
function leftPadZero(value) {
    if (value < 10) {
        return "0" + value;
    }
    return value.toString();
}
exports.leftPadZero = leftPadZero;
function getTime(date) {
    return leftPadZero(date.getHours()) + ":" + leftPadZero(date.getMinutes());
}
exports.getTime = getTime;
function mapDayToString(date, now) {
    if (!now || !isValidDate(now)) {
        now = new Date();
    }
    else {
        now = new Date(now.getTime());
    }
    if (now.getFullYear() !== date.getFullYear() || now.getMonth() !== date.getMonth()) {
        return undefined;
    }
    if (now.getDate() === date.getDate()) {
        return 'сегодня';
    }
    now.setDate(now.getDate() - 1);
    if (now.getDate() === date.getDate()) {
        return 'вчера';
    }
    now.setDate(now.getDate() - 1);
    if (now.getDate() === date.getDate()) {
        return 'позавчера';
    }
    return undefined;
}
exports.mapDayToString = mapDayToString;
function getFormattedDate(date, now) {
    var day = mapDayToString(date);
    if (!now || !isValidDate(now)) {
        now = new Date();
    }
    else {
        now = new Date(now.getTime());
    }
    if (day) {
        return day + " " + getTime(date);
    }
    if (now.getFullYear() === date.getFullYear()) {
        return date.getDate() + " " + monthNames[date.getMonth()] + " " + getTime(date);
    }
    return date.getDate() + " " + monthNames[date.getMonth()] + " " + date.getFullYear();
}
exports.getFormattedDate = getFormattedDate;


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var devices = [
    {
        regex: /iPhone/i,
        type: 'phone',
    }, {
        regex: /iPod/i,
        type: 'phone',
    }, {
        regex: /iPad/i,
        type: 'tablet',
    }, {
        regex: /(?=.*\bAndroid\b)(?=.*\bMobile\b)/i,
        type: 'phone',
    }, {
        regex: /Android/i,
        type: 'tablet',
    }, {
        regex: /Windows Phone/i,
        type: 'phone',
    }, {
        regex: /(?=.*\bWindows\b)(?=.*\bARM\b)/i,
        type: 'tablet',
    }, {
        regex: /(BlackBerry|BB10)/i,
        type: 'phone',
    }, {
        regex: /Opera Mini/i,
        type: 'phone',
    }, {
        regex: /(CriOS|Chrome)(?=.*\bMobile\b)/i,
        type: 'phone',
    }, {
        regex: /(?=.*\bFirefox\b)(?=.*\bMobile\b)/i,
        type: 'phone',
    },
];
exports.identifyDeviceType = function (userAgent) {
    if (userAgent) {
        for (var i = 0; i < devices.length; i++) {
            var device = devices[i];
            if (device.regex.test(userAgent)) {
                return device.type;
            }
        }
    }
    return 'desktop';
};


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function normalizeHost(host) {
    var rules = [
        [/^([^\.]+)\.micro\.cian\.tech$/, undefined],
        [/^(?:[^\.]+\.)?beta\d*\.stage\.cian\.ru$/, 'python'],
        [/^[^\.]+\.([^\.]+)\.stage\.cian\.ru$/, undefined],
        [/^(?:[^\.]+\.)?[^\.]+\.dev\d*\.cian\.ru$/, 'python'],
        [/^(?:[^\.]+\.)?beta\d*\.cian\.ru$/, 'python'],
        [/^(?:[^\.]+\.)?cian\.ru$/, 'python'],
    ];
    for (var _i = 0, rules_1 = rules; _i < rules_1.length; _i++) {
        var _a = rules_1[_i], pattern = _a[0], name_1 = _a[1];
        var matches = pattern.exec(host);
        if (matches) {
            if (name_1) {
                return name_1;
            }
            else {
                return matches[1];
            }
        }
    }
    return host;
}
exports.normalizeHost = normalizeHost;


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var NOT_NUMBER_REX = /[^0-9]/g;
var NUMBER_GROUP_REX = /.{1,3}/g;
function parseNumber(s) {
    var sign = s[0] === '-' ? '-' : '';
    var _a = s.split('.'), integer = _a[0], fractional = _a[1];
    return {
        fractional: fractional ? fractional.replace(NOT_NUMBER_REX, '') : '',
        integer: integer.replace(NOT_NUMBER_REX, ''),
        sign: sign,
    };
}
exports.parseNumber = parseNumber;
function numberToPrettyString(defaultNumber, separator) {
    if (separator === void 0) { separator = ','; }
    var _a = parseNumber(String(defaultNumber)), fractional = _a.fractional, integer = _a.integer, sign = _a.sign;
    var parsedInteger = reverseString(integer).match(NUMBER_GROUP_REX) || [];
    var prettyInteger = parsedInteger.reverse().map(reverseString).join(' ');
    return !fractional ? "" + sign + prettyInteger : "" + sign + prettyInteger + separator + fractional;
}
exports.numberToPrettyString = numberToPrettyString;
function reverseString(s) {
    return s.split('').reverse().join('');
}


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function plural(n, variants) {
    if (n % 10 === 1 && n % 100 !== 11) {
        return variants[0];
    }
    if (n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20)) {
        return variants[1];
    }
    return variants[2];
}
exports.plural = plural;


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.scrollTo = function (params) {
    var containerElementClientHeight = params.containerElement.clientHeight;
    var containerElementScrollTop = params.containerElement.scrollTop;
    var targetElementOffsetTop = params.targetElement.offsetTop;
    var targetElementScrollHeight = params.targetElement.scrollHeight;
    if (params.center) {
        params.containerElement.scrollTop =
            targetElementOffsetTop
                - containerElementClientHeight / 2
                + targetElementScrollHeight / 2;
    }
    else {
        var containerBottom = containerElementScrollTop + containerElementClientHeight;
        var valueBottom = targetElementOffsetTop + targetElementScrollHeight;
        if (valueBottom > containerBottom) {
            params.containerElement.scrollTop = valueBottom - containerElementClientHeight;
        }
        else if (targetElementOffsetTop < containerElementScrollTop) {
            params.containerElement.scrollTop = targetElementOffsetTop;
        }
    }
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var defaultOptions = {
    billionPostfix: 'млрд.',
    fractionalLength: 2,
    millionPostfix: 'млн.',
    separator: undefined,
    thousandPostfix: 'тыс.',
};
function shortenNumber(i, userOptions) {
    var options = userOptions
        ? Object.assign({}, defaultOptions, userOptions)
        : defaultOptions;
    var getFractional = fractional(options.fractionalLength);
    var applyPostfix = withPostfix(options.separator);
    if (i >= 1000000000) {
        var value = getFractional(i, 1000000000);
        return applyPostfix(value, options.billionPostfix);
    }
    else if (i >= 1000000) {
        var value = getFractional(i, 1000000);
        return applyPostfix(String(value), options.millionPostfix);
    }
    else if (i >= 1000) {
        var value = getFractional(i, 1000);
        return applyPostfix(value, options.thousandPostfix);
    }
    else {
        var value = getFractional(i);
        return applySeparator(Number(value), options.separator);
    }
}
exports.shortenNumber = shortenNumber;
function withPostfix(separator) {
    return function (value, postfix) {
        return applySeparator(Number(value), separator) + " " + postfix;
    };
}
function fractional(fractionalLength) {
    return function (value, divider) {
        if (!divider) {
            return value.toFixed(fractionalLength);
        }
        var num = value / divider;
        var numAsArray = String(num).split('.');
        var originalFractionChapter = numAsArray[1];
        if (originalFractionChapter &&
            originalFractionChapter.length > 2 &&
            Number(originalFractionChapter.slice(-1)) < 5) {
            return num.toFixed(fractionalLength);
        }
        else if (originalFractionChapter) {
            var newFractionChapter = originalFractionChapter.length > fractionalLength
                ? originalFractionChapter.slice(0, fractionalLength)
                : originalFractionChapter;
            return numAsArray[0] + "." + newFractionChapter;
        }
        return String(num);
    };
}
function applySeparator(value, separator) {
    if (typeof separator === 'string') {
        return value.toString().replace('.', separator);
    }
    return value.toString();
}


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function isStyleProps(styleArgument) {
    if (!!styleArgument && typeof styleArgument === 'object' && !Array.isArray(styleArgument)) {
        return styleArgument.hasOwnProperty('style') && styleArgument.hasOwnProperty('className');
    }
    return false;
}
function mergeClassNames(target, cls) {
    if (!cls || !cls.length) {
        return target;
    }
    return target.length === 0
        ? cls
        : target + " " + cls;
}
function mergeStyleProperties(target, style) {
    return tslib_1.__assign({}, target, style);
}
function mergerStyleConfigs(target, style) {
    return {
        className: mergeClassNames(target.className, style.className),
        style: mergeStyleProperties(target.style, style.style),
    };
}
// tslint:disable-next-line:no-any
function isStyleConifg(target) {
    if (!target) {
        return false;
    }
    return typeof target === 'object' || typeof target === 'string';
}
function reducer(acc, style) {
    if (!isStyleConifg(style)) {
        return acc;
    }
    if (Array.isArray(style)) {
        return style.reduce(reducer, acc);
    }
    if (typeof style === 'object') {
        return isStyleProps(style)
            ? mergerStyleConfigs(acc, style)
            : mergerStyleConfigs(acc, { className: '', style: style });
    }
    acc.className = mergeClassNames(acc.className, style);
    return acc;
}
function mergeStyles() {
    var styles = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        styles[_i] = arguments[_i];
    }
    return styles.reduce(reducer, { style: {}, className: '' });
}
exports.mergeStyles = mergeStyles;


/***/ })
/******/ ]);
//# sourceMappingURL=frontend-utils.js.map

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var VisualSize;
(function (VisualSize) {
    VisualSize[VisualSize["SMALL"] = 0] = "SMALL";
    VisualSize[VisualSize["MEDIUM"] = 1] = "MEDIUM";
    VisualSize[VisualSize["LARGE"] = 2] = "LARGE";
    VisualSize[VisualSize["MOBILE_MEDIUM"] = 3] = "MOBILE_MEDIUM";
})(VisualSize = exports.VisualSize || (exports.VisualSize = {}));
var isStyleProps = function (styleProps) {
    return styleProps.style !== undefined && styleProps.className !== undefined;
};
function mergeStyles() {
    var styles = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        styles[_i] = arguments[_i];
    }
    return [].concat.apply([], styles)
        .reduce(function (acc, style) {
        if (typeof style === 'string') {
            acc.className += acc.className.length === 0
                ? style
                : " " + style;
        }
        else if (typeof style === 'object') {
            if (isStyleProps(style)) {
                acc.className += acc.className.length === 0
                    ? style.className
                    : " " + style.className;
                Object.assign(acc.style, style.style);
            }
            else {
                Object.assign(acc.style, style);
            }
        }
        return acc;
    }, { style: {}, className: '' });
}
exports.mergeStyles = mergeStyles;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var text_field_component_1 = __webpack_require__(31);
exports.TextField = text_field_component_1.TextField;
exports.default = text_field_component_1.TextField;


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(1);
var React = __webpack_require__(0);
var utils_1 = __webpack_require__(2);
var styles = __webpack_require__(36);
var PopupArrow;
(function (PopupArrow) {
    PopupArrow[PopupArrow["NONE"] = 0] = "NONE";
    PopupArrow[PopupArrow["LEFT"] = 1] = "LEFT";
    PopupArrow[PopupArrow["CENTER"] = 2] = "CENTER";
    PopupArrow[PopupArrow["RIGHT"] = 3] = "RIGHT";
})(PopupArrow = exports.PopupArrow || (exports.PopupArrow = {}));
var Popup = /** @class */ (function (_super) {
    tslib_1.__extends(Popup, _super);
    function Popup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Popup.prototype.render = function () {
        return (React.createElement("div", tslib_1.__assign({}, utils_1.mergeStyles(styles['container'], this.props.arrow !== PopupArrow.NONE && styles['arrow'], this.props.arrow === PopupArrow.LEFT && styles['arrow-left'], this.props.arrow === PopupArrow.CENTER && styles['arrow-center'], this.props.arrow === PopupArrow.RIGHT && styles['arrow-right'], this.props.containerStyle)), this.props.children));
    };
    Popup.defaultProps = {
        arrow: PopupArrow.NONE,
    };
    return Popup;
}(React.Component));
exports.default = Popup;


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function createInputChangeHandler(rawValueHandler) {
    return function (event) {
        rawValueHandler(event.currentTarget.value);
    };
}
exports.createInputChangeHandler = createInputChangeHandler;
function getKeyboardEventCode(event) {
    /* tslint:disable:no-any */
    var code = event.code || event.key || event.keyIdentifier;
    /* tslint:enable:no-any */
    return code;
}
exports.getKeyboardEventCode = getKeyboardEventCode;
function getKeyPressed(event) {
    /* tslint:disable:no-any */
    var letter = event.key ||
        String.fromCharCode(parseInt(event.keyIdentifier.replace('U+', ''), 16));
    /* tslint:enable:no-any */
    return /^[\wа-яА-ЯЁё]$/.test(letter) ? letter : undefined;
}
exports.getKeyPressed = getKeyPressed;
function on(el, eventName, callback) {
    if (el && el.addEventListener) {
        el.addEventListener(eventName, callback, false);
    }
}
exports.on = on;
function off(el, eventName, callback) {
    if (el && el.removeEventListener) {
        el.removeEventListener(eventName, callback);
    }
}
exports.off = off;


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var _a, _b, _c, _d;
var style_1 = __webpack_require__(3);
var object_helpers_1 = __webpack_require__(40);
var linkStyle = __webpack_require__(41);
var buttonStyle = __webpack_require__(9);
// tslint:disable-next-line:variable-name
exports.LinkTheme = {
    BLUE: 'link/blue',
};
exports.linkThemeStyles = (_a = {},
    _a[exports.LinkTheme.BLUE] = '',
    _a);
exports.linkSizeStyles = (_b = {},
    _b[style_1.VisualSize.SMALL] = linkStyle['small'],
    _b[style_1.VisualSize.MEDIUM] = linkStyle['medium'],
    _b[style_1.VisualSize.LARGE] = linkStyle['large'],
    _b);
exports.isLinkTheme = function (theme) { return object_helpers_1.getValues(exports.LinkTheme).indexOf(theme) !== -1; };
// tslint:disable-next-line:variable-name
exports.ButtonTheme = {
    TOGGLE: 'button/toggle',
    TOGGLE_ACTIVE: 'button/toggleActive',
    TOGGLE_ACTIVE_UNCKECKABLE: 'button/toggleActiveUncheckable',
    BLUE: 'button/blue',
    BLUE_SOLID: 'button/solid',
    ORANGE: 'button/orange',
    ORANGE_SOLID: 'button/orangeSolid',
    WHITE: 'button/white',
    BLUELIGHT_SOLID: 'button/blueLightSolid',
};
exports.buttonThemeStyles = (_c = {},
    _c[exports.ButtonTheme.BLUE] = buttonStyle['blue'],
    _c[exports.ButtonTheme.BLUE_SOLID] = buttonStyle['blue_solid'],
    _c[exports.ButtonTheme.ORANGE] = buttonStyle['orange'],
    _c[exports.ButtonTheme.ORANGE_SOLID] = buttonStyle['orange_solid'],
    _c[exports.ButtonTheme.WHITE] = buttonStyle['white'],
    _c[exports.ButtonTheme.TOGGLE] = buttonStyle['toggle'],
    _c[exports.ButtonTheme.TOGGLE_ACTIVE] = buttonStyle['toggle_active'],
    _c[exports.ButtonTheme.TOGGLE_ACTIVE_UNCKECKABLE] = buttonStyle['toggle_active_uncheckable'],
    _c[exports.ButtonTheme.BLUELIGHT_SOLID] = buttonStyle['bluelight_solid'],
    _c);
exports.buttonSizeStyles = (_d = {},
    _d[style_1.VisualSize.SMALL] = buttonStyle['small'],
    _d[style_1.VisualSize.MEDIUM] = buttonStyle['medium'],
    _d[style_1.VisualSize.LARGE] = buttonStyle['large'],
    _d[style_1.VisualSize.MOBILE_MEDIUM] = buttonStyle['mobileMedium'],
    _d);
exports.isButtonTheme = function (theme) { return object_helpers_1.getValues(exports.ButtonTheme).indexOf(theme) !== -1; };
exports.getStyles = function (_a) {
    var size = _a.size, theme = _a.theme, mobile = _a.mobile;
    var sizeStyles = {};
    var themeStyles = {};
    var containerStyle = [];
    var extraStyles = [];
    if (exports.isButtonTheme(theme || exports.ButtonTheme.BLUE)) {
        containerStyle = buttonStyle['container'];
        sizeStyles = exports.buttonSizeStyles;
        themeStyles = exports.buttonThemeStyles;
        if (mobile) {
            extraStyles.push(buttonStyle['mobile']);
        }
    }
    else if (exports.isLinkTheme(theme || exports.ButtonTheme.BLUE)) {
        containerStyle = linkStyle['container'];
        sizeStyles = exports.linkSizeStyles;
        themeStyles = exports.linkThemeStyles;
    }
    else {
        throw new Error('Unknown theme supplied to Button or Link!');
    }
    return [
        containerStyle
    ].concat(extraStyles, [
        sizeStyles[size || style_1.VisualSize.SMALL],
        themeStyles[theme || exports.ButtonTheme.BLUE],
    ]);
};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(1);
var utils_1 = __webpack_require__(2);
var React = __webpack_require__(0);
var react_1 = __webpack_require__(0);
var style_1 = __webpack_require__(3);
var buttonLink_1 = __webpack_require__(7);
var styles = __webpack_require__(9);
var Button = /** @class */ (function (_super) {
    tslib_1.__extends(Button, _super);
    function Button(props) {
        var _a, _b;
        var _this = _super.call(this, props) || this;
        _this.button = null;
        _this.buttonThemeStyles = (_a = {},
            _a[buttonLink_1.ButtonTheme.BLUE] = styles['blue'],
            _a[buttonLink_1.ButtonTheme.BLUE_SOLID] = styles['blue_solid'],
            _a[buttonLink_1.ButtonTheme.ORANGE] = styles['orange'],
            _a[buttonLink_1.ButtonTheme.ORANGE_SOLID] = styles['orange_solid'],
            _a[buttonLink_1.ButtonTheme.WHITE] = styles['white'],
            _a[buttonLink_1.ButtonTheme.TOGGLE] = styles['toggle'],
            _a[buttonLink_1.ButtonTheme.TOGGLE_ACTIVE] = styles['toggle_active'],
            _a[buttonLink_1.ButtonTheme.TOGGLE_ACTIVE_UNCKECKABLE] = styles['toggle_active_uncheckable'],
            _a[buttonLink_1.ButtonTheme.BLUELIGHT_SOLID] = styles['bluelight_solid'],
            _a);
        _this.buttonSizeStyles = (_b = {},
            _b[style_1.VisualSize.SMALL] = styles['small'],
            _b[style_1.VisualSize.MEDIUM] = styles['medium'],
            _b[style_1.VisualSize.LARGE] = styles['large'],
            _b[style_1.VisualSize.MOBILE_MEDIUM] = styles['mobileMedium'],
            _b);
        return _this;
    }
    Button.prototype.focus = function () {
        if (this.button) {
            this.button.focus();
        }
    };
    Button.prototype.blur = function () {
        if (this.button) {
            this.button.blur();
        }
    };
    Button.prototype.render = function () {
        var _this = this;
        return (React.createElement("button", tslib_1.__assign({}, utils_1.mergeStyles(this.getStyles(this.props), this.props.buttonStyle), { ref: function (button) { return _this.button = button; }, type: this.props.type, disabled: this.props.disabled, onClick: this.props.onClick, onKeyDown: this.props.onKeyDown, "data-mark": this.props.dataMark }), this.props.children));
    };
    Button.prototype.getStyles = function (_a) {
        var size = _a.size, theme = _a.theme, mobile = _a.mobile;
        var sizeStyles = {};
        var themeStyles = {};
        var extraStyles = [];
        var containerStyle = styles['container'];
        sizeStyles = this.buttonSizeStyles;
        themeStyles = this.buttonThemeStyles;
        if (mobile) {
            extraStyles.push(styles['mobile']);
        }
        return [
            containerStyle
        ].concat(extraStyles, [
            sizeStyles[size],
            themeStyles[theme],
        ]);
    };
    ;
    Button.defaultProps = {
        theme: 'button/blue',
        size: style_1.VisualSize.SMALL,
        type: 'button',
    };
    return Button;
}(react_1.Component));
exports.default = Button;


/***/ }),
/* 9 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"components-container-fK1MYP2JLG6","small":"components-small-b7xRtaPIFqe","medium":"components-medium-dTzQtw9h28m","large":"components-large-30XBmiVT8IA","mobileMedium":"components-mobileMedium-8xQDsJM38kU","blue":"components-blue-d2FJZI8WcgS","mobile":"components-mobile-eLu3sqSgXCu","blue_solid":"components-blue_solid-i99yMO3U76q","toggle_active":"components-toggle_active-YiFJ5mEsEw","toggle_active_uncheckable":"components-toggle_active_uncheckable-1ddaulICrCK","orange":"components-orange-4H63L3K7ZSG","orange_solid":"components-orange_solid-3sR7SNj2reE","white":"components-white-hPhWgwbp1mQ","toggle":"components-toggle-fBUq61wtm8a","bluelight_solid":"components-bluelight_solid-6WLs4IMCNac"};

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(1);
var utils_1 = __webpack_require__(2);
var React = __webpack_require__(0);
var debounce_1 = __webpack_require__(49);
var starts_with_1 = __webpack_require__(50);
var outside_click_1 = __webpack_require__(20);
var events_1 = __webpack_require__(6);
var styles = __webpack_require__(52);
;
var AbstractDropdown = /** @class */ (function (_super) {
    tslib_1.__extends(AbstractDropdown, _super);
    function AbstractDropdown(props) {
        var _this = _super.call(this, props) || this;
        _this.button = null;
        _this.popupContent = null;
        _this.state = {
            opened: false,
            selectedIndex: null,
        };
        _this.searchTerm = '';
        _this.clearTerm = debounce_1.debounce(function () { _this.searchTerm = ''; }, 450);
        return _this;
    }
    AbstractDropdown.prototype.render = function () {
        var _this = this;
        var _a = this.calculateValues(), activeValue = _a.activeValue, selectedLabel = _a.selectedLabel, selectedValue = _a.selectedValue;
        return (React.createElement(outside_click_1.default, { onOutsideClick: function () { return _this.close(); }, rootElement: React.createElement("span", tslib_1.__assign({}, utils_1.mergeStyles(styles['container'], this.state.opened && styles['opened'], this.props.required && styles['required'], this.props.containerStyle))) },
            this.renderButton(selectedLabel),
            this.state.opened && this.renderPopup({
                activeValue: activeValue,
                selectedValue: selectedValue,
            })));
    };
    AbstractDropdown.prototype.focus = function () {
        if (this.button) {
            this.button.focus();
        }
        this.open();
    };
    AbstractDropdown.prototype.blur = function () {
        if (this.button) {
            this.button.blur();
        }
        this.close();
    };
    AbstractDropdown.prototype.toggleOpened = function () {
        if (this.state.opened) {
            this.close();
        }
        else {
            this.open();
        }
    };
    AbstractDropdown.prototype.handleValueMouseOver = function (value) {
        var index = this.props.values.indexOf(value);
        var selectedIndex = index >= 0 ? index : null;
        this.setState({ selectedIndex: selectedIndex });
    };
    AbstractDropdown.prototype.handleKeyDown = function (event) {
        var nativeEvent = event.nativeEvent;
        var code = events_1.getKeyboardEventCode(nativeEvent);
        if (code === 'Escape') {
            this.close();
            return;
        }
        if (this.props.multiple) {
            // disable keyboard iteraction while selectedValue is not implemented in PopupContent with multiple values
            return;
        }
        switch (code) {
            case 'ArrowDown':
            case 'Down':
                event.preventDefault();
                this.incrementSelectedIndex();
                break;
            case 'ArrowUp':
            case 'Up':
                event.preventDefault();
                this.decrementSelectedIndex();
                break;
            case 'NumpadEnter':
            case 'Enter':
                event.preventDefault();
                if (typeof this.state.selectedIndex === 'number') {
                    this.handleValueClick(this.props.values[this.state.selectedIndex]);
                }
                break;
            default:
                var letter = events_1.getKeyPressed(nativeEvent);
                this.clearTerm();
                if (typeof letter !== 'undefined') {
                    this.searchTerm += letter;
                }
                var index = this.findValueIndex(this.searchTerm);
                if (index >= 0) {
                    this.setSelectedIndex(index);
                }
                break;
        }
    };
    AbstractDropdown.prototype.handleValueClick = function (value) {
        if (this.props.multiple) {
            var changedValue = this.props.value;
            var valueIndex = changedValue.indexOf(value.value);
            if (valueIndex >= 0) {
                changedValue.splice(valueIndex, 1);
            }
            else {
                changedValue.push(value.value);
            }
            this.props.onValueChange(changedValue);
        }
        else {
            this.props.onValueChange(value.value);
            this.close();
        }
    };
    AbstractDropdown.prototype.close = function () {
        if (this.button) {
            this.button.blur();
        }
        this.setState({
            opened: false,
            selectedIndex: null,
        });
    };
    AbstractDropdown.prototype.open = function () {
        var _this = this;
        if (this.button) {
            this.button.focus();
        }
        var selectedValue = this.props.values
            .filter(function (value) { return value.value === _this.props.value; })
            .shift();
        var selectedIndex = this.props.values.indexOf(selectedValue);
        this.setState({
            opened: true,
            selectedIndex: selectedIndex >= 0 ? selectedIndex : null,
        });
    };
    AbstractDropdown.prototype.calculateValues = function () {
        var convertedValue = Array.isArray(this.props.value) ? this.props.value : [this.props.value];
        var activeValue = this.props.values
            .filter(function (value) { return convertedValue.indexOf(value.value) >= 0; });
        var selectedLabel = activeValue.length > 0
            ? activeValue.map(function (item) { return item.label; }).join(', ')
            : React.createElement("span", tslib_1.__assign({}, utils_1.mergeStyles(styles[this.state.opened ? 'placeholder-opened' : 'placeholder'], this.state.opened ? this.props.placeholderOpenedStyle : this.props.placeholderStyle)), this.props.placeholder);
        var selectedValue = [];
        if (this.props.multiple) {
            selectedValue = activeValue;
        }
        else if (typeof this.state.selectedIndex === 'number') {
            selectedValue = [
                this.props.values[this.state.selectedIndex],
            ];
        }
        return {
            activeValue: activeValue,
            selectedLabel: selectedLabel,
            selectedValue: selectedValue,
        };
    };
    AbstractDropdown.prototype.incrementSelectedIndex = function () {
        var selectedIndex = typeof this.state.selectedIndex !== 'number'
            ? 0
            : this.state.selectedIndex + 1;
        this.setSelectedIndex(selectedIndex);
    };
    AbstractDropdown.prototype.decrementSelectedIndex = function () {
        var selectedIndex = typeof this.state.selectedIndex !== 'number'
            ? this.props.values.length - 1
            : this.state.selectedIndex - 1;
        this.setSelectedIndex(selectedIndex);
    };
    AbstractDropdown.prototype.setSelectedIndex = function (selectedIndex) {
        if (selectedIndex < 0) {
            selectedIndex = 0;
        }
        if (selectedIndex >= this.props.values.length) {
            selectedIndex = this.props.values.length - 1;
        }
        this.setState({
            selectedIndex: selectedIndex,
        });
        if (this.popupContent && this.popupContent.scrollTo) {
            this.popupContent.scrollTo(selectedIndex);
        }
    };
    AbstractDropdown.prototype.findValueIndex = function (startingLetters) {
        if (startingLetters === '') {
            return -1;
        }
        var index = -1;
        this.props.values.some(function (value, i) {
            if (starts_with_1.startsWith(value.label.toLowerCase(), startingLetters.toLowerCase())) {
                index = i;
                return true;
            }
            return false;
        });
        return index;
    };
    AbstractDropdown.defaultProps = {
        multiple: false,
    };
    return AbstractDropdown;
}(React.Component));
exports.AbstractDropdown = AbstractDropdown;


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(1);
var React = __webpack_require__(0);
var utils_1 = __webpack_require__(2);
var checkbox_field_1 = __webpack_require__(13);
var styles = __webpack_require__(18);
var popup_content_1 = __webpack_require__(17);
var PopupContent = /** @class */ (function (_super) {
    tslib_1.__extends(PopupContent, _super);
    function PopupContent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PopupContent.prototype.componentDidMount = function () {
        var valueToScroll = Array.isArray(this.props.value) ? this.props.value[0] : this.props.value;
        if (this.props.value) {
            this.scrollTo(this.props.values.indexOf(valueToScroll), true);
        }
    };
    PopupContent.prototype.renderItemsForMultipleChoices = function () {
        var _this = this;
        return (React.createElement("div", null, this.props.values.map(function (value, index) {
            var active = _this.props.value != null && _this.props.value.indexOf(value) >= 0;
            return (React.createElement("div", tslib_1.__assign({ ref: function (valueElement) { return _this.values[index] = valueElement; }, key: value.value + "-" + index }, utils_1.mergeStyles(styles['value'], styles['value-checkbox'], active && _this.props.valueActiveStyle, _this.props.valueStyle), { onMouseOver: function () { return _this.handleValueMouseOver(function () { return _this.props.onValueMouseOver(value); }); } }),
                React.createElement(checkbox_field_1.default, { containerStyle: { display: 'block' }, labelStyle: { display: 'block' }, label: value.label, value: _this.props.value.indexOf(value) >= 0, onValueChange: function () { return _this.props.onValueClick(value); } })));
        })));
    };
    PopupContent.prototype.renderItemsForSingleChoice = function () {
        var _this = this;
        return (React.createElement("div", null, this.props.values.map(function (value, index) {
            var active = _this.props.value != null && _this.props.value.indexOf(value) >= 0;
            var selected = _this.props.selectedValue != null && _this.props.selectedValue.indexOf(value) >= 0;
            return (React.createElement("div", tslib_1.__assign({ ref: function (valueElement) { return _this.values[index] = valueElement; }, key: value.value + "-" + index }, utils_1.mergeStyles(styles['value'], active && styles['value-active'], active && _this.props.valueActiveStyle, selected && styles['value-selected'], selected && _this.props.valueSelectedStyle, _this.props.valueStyle), { onMouseOver: function () { return _this.handleValueMouseOver(function () { return _this.props.onValueMouseOver(value); }); }, onMouseDown: function (event) { return event.preventDefault(); }, onClick: function () { return _this.props.onValueClick(value); } }), value.label));
        })));
    };
    return PopupContent;
}(popup_content_1.AbstractPopupContent));
exports.default = PopupContent;


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(1);
var React = __webpack_require__(0);
var utils_1 = __webpack_require__(2);
var checkbox_field_1 = __webpack_require__(13);
var popup_content_1 = __webpack_require__(17);
var checkboxFieldStyles = __webpack_require__(16);
var styles = __webpack_require__(35);
exports.DELIMITER = 'DROPDOWN_SEARCH_DELIMITER';
exports.Delimiter = {
    value: exports.DELIMITER,
    label: '-',
};
var PopupContentSearch = /** @class */ (function (_super) {
    tslib_1.__extends(PopupContentSearch, _super);
    function PopupContentSearch() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PopupContentSearch.prototype.componentDidMount = function () {
        var valueToScroll = Array.isArray(this.props.value) ? this.props.value[0] : this.props.value;
        if (this.props.value) {
            this.scrollTo(this.props.values.indexOf(valueToScroll), true);
        }
    };
    PopupContentSearch.prototype.renderItemsForMultipleChoices = function () {
        var _this = this;
        return (React.createElement("div", null,
            this.props.values.map(function (value, index) {
                if (value === exports.Delimiter) {
                    return (React.createElement("div", tslib_1.__assign({ key: 'delimiter' }, utils_1.mergeStyles(_this.props.delimiterStyle))));
                }
                else {
                    return (React.createElement("div", tslib_1.__assign({ key: value.value, ref: function (valueElement) { return _this.values[index] = valueElement; } }, utils_1.mergeStyles(_this.props.valueStyle)),
                        React.createElement(checkbox_field_1.default, { value: _this.props.selectedValue.indexOf(value) >= 0, label: value.label, onValueChange: function () { return _this.props.onValueClick(value); } })));
                }
            }),
            this.props.values.length === 0 && this.renderNotFound()));
    };
    PopupContentSearch.prototype.renderItemsForSingleChoice = function () {
        var _this = this;
        return (React.createElement("div", null,
            this.props.values.map(function (value, index) {
                if (value.value === exports.DELIMITER) {
                    return (React.createElement("div", { className: checkboxFieldStyles['delimiter'] }));
                }
                else {
                    return (React.createElement("div", tslib_1.__assign({ key: value.value, ref: function (valueElement) { return _this.values[index] = valueElement; } }, utils_1.mergeStyles(_this.props.valueStyle)),
                        React.createElement(checkbox_field_1.default, { value: _this.props.selectedValue.indexOf(value) >= 0, label: value.label, onValueChange: function () { return _this.props.onValueClick(value); } })));
                }
            }),
            this.props.values.length === 0 && this.renderNotFound()));
    };
    PopupContentSearch.prototype.renderNotFound = function () {
        return (React.createElement("div", tslib_1.__assign({}, utils_1.mergeStyles(styles['item'], this.props.valueStyle)), this.props.valueNotFoundText));
    };
    PopupContentSearch.defaultProps = {
        valueNotFoundText: 'Ничего не найдено',
    };
    return PopupContentSearch;
}(popup_content_1.AbstractPopupContent));
exports.default = PopupContentSearch;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(1);
var React = __webpack_require__(0);
var utils_1 = __webpack_require__(2);
var styles = __webpack_require__(16);
var CheckboxField = /** @class */ (function (_super) {
    tslib_1.__extends(CheckboxField, _super);
    function CheckboxField() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CheckboxField.prototype.render = function () {
        var _this = this;
        var _a = this.props, value = _a.value, required = _a.required, invalid = _a.invalid, disabled = _a.disabled, mobile = _a.mobile;
        return (React.createElement("span", tslib_1.__assign({}, utils_1.mergeStyles(styles['container'], !!value && styles['checked'], required && styles['required'], invalid && styles['invalid'], disabled && styles['disabled'], mobile && styles['mobile'], this.props.containerStyle)),
            React.createElement("label", tslib_1.__assign({}, utils_1.mergeStyles(styles['label'], mobile && styles['mobile'], this.props.labelStyle), { onClick: function () { return _this.handleClick(); } }), this.props.label)));
    };
    CheckboxField.prototype.handleClick = function () {
        if (this.props.disabled) {
            return;
        }
        this.props.onValueChange(!this.props.value);
    };
    return CheckboxField;
}(React.Component));
exports.default = CheckboxField;


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var FavoriteRegions;
(function (FavoriteRegions) {
    FavoriteRegions[FavoriteRegions["Moscow"] = 1] = "Moscow";
    FavoriteRegions[FavoriteRegions["SPB"] = 2] = "SPB";
    FavoriteRegions[FavoriteRegions["MO"] = 4593] = "MO";
    FavoriteRegions[FavoriteRegions["LO"] = 4588] = "LO";
})(FavoriteRegions = exports.FavoriteRegions || (exports.FavoriteRegions = {}));
exports.MOSCOW_MO = 'Москва и МО';
exports.SPB_LO = 'Санкт-Петербург и ЛО';
var SeparatorProps = /** @class */ (function () {
    function SeparatorProps(columnsCount) {
        this.columnsCount = 4;
        this.relTitleHeight = 2.5;
        if (columnsCount !== undefined && columnsCount !== 0) {
            this.columnsCount = columnsCount;
        }
    }
    return SeparatorProps;
}());
exports.SeparatorProps = SeparatorProps;
function separateByColumns(array, props) {
    var totalHeight = calcTotalHeight(array, props.relTitleHeight);
    var targetHeight = totalHeight / props.columnsCount;
    var bucketHeight = 0;
    return array.reduce(function (buckets, group) {
        if (!buckets.length) {
            buckets.push([]);
        }
        var currBucket = buckets[buckets.length - 1];
        var nextGroupHeight = group[1].length + props.relTitleHeight;
        if (currBucket.length === 0) {
            currBucket.push(group);
            bucketHeight += nextGroupHeight;
            return buckets;
        }
        var futureHeight = bucketHeight + nextGroupHeight;
        if (targetHeight - futureHeight > 0) {
            currBucket.push(group);
            bucketHeight += nextGroupHeight;
            return buckets;
        }
        if (buckets.length === props.columnsCount - 1) {
            currBucket.push(group);
            buckets.push([]);
            bucketHeight = 0;
            return buckets;
        }
        if (buckets.length === props.columnsCount) {
            currBucket.push(group);
            bucketHeight = nextGroupHeight;
            return buckets;
        }
        if ((targetHeight - futureHeight) * -1 >= (targetHeight - bucketHeight)) {
            buckets.push([]);
            currBucket = buckets[buckets.length - 1];
            currBucket.push(group);
            bucketHeight = nextGroupHeight;
        }
        else {
            currBucket = buckets[buckets.length - 1];
            currBucket.push(group);
            buckets.push([]);
            bucketHeight = 0;
        }
        return buckets;
        // tslint:disable-next-line:no-any
    }, []);
}
exports.default = separateByColumns;
function calcTotalHeight(alphabet, relTitleHeight) {
    return alphabet.reduce(function (sum, group) {
        sum += relTitleHeight;
        sum += group[1].length;
        return sum;
    }, 0);
}
function convertToViewModel(regions) {
    var viewModel = regions
        //удаляем регионы для которых нет данных
        .filter(function (region) { return region.id !== FavoriteRegions.MO && region.id !== FavoriteRegions.LO; })
        //переименовываем избранные регионы
        .map(function (region) {
        switch (region.id) {
            case FavoriteRegions.Moscow:
                region.displayName = exports.MOSCOW_MO;
                break;
            case FavoriteRegions.SPB:
                region.displayName = exports.SPB_LO;
                break;
            default:
                break;
        }
        return region;
    })
        //сортируем регионы в алфавитном порядке
        .sort(function (previosRegion, nextRegion) {
        if (previosRegion.displayName === nextRegion.displayName) {
            return 0;
        }
        return previosRegion.displayName > nextRegion.displayName ?
            1 : -1;
    })
        //разбиваем массив на структуру и двух: 1ый список избранных, 2ой регионы в алфавитном порядке
        .reduce(function (prev, currentValue) {
        if (currentValue.id === FavoriteRegions.Moscow ||
            currentValue.id === FavoriteRegions.SPB) {
            prev[0].push(currentValue);
            return prev;
        }
        prev[1].push(currentValue);
        return prev;
    }, [[], []])
        //собираем новую коллекцию
        .reduce(function (previousValue, currentValue, index) {
        if (index === 0) {
            previousValue.favorites = currentValue;
        }
        else {
            previousValue.alphabet = devideListToAlphabet(currentValue);
        }
        return previousValue;
    }, {
        favorites: [],
        alphabet: [],
    });
    return viewModel || regions;
}
exports.convertToViewModel = convertToViewModel;
function devideListToAlphabet(regions) {
    return regions.reduce(function (previousValue, currentValue) {
        var regionIndex = currentValue.displayName[0];
        if (previousValue.length === 0) {
            previousValue.push([regionIndex, [currentValue]]);
            return previousValue;
        }
        var currentAlphabetIndex = previousValue[previousValue.length - 1][0];
        if (currentAlphabetIndex === regionIndex) {
            previousValue[previousValue.length - 1][1].push(currentValue);
        }
        else {
            previousValue.push([regionIndex, [currentValue]]);
        }
        return previousValue;
    }, []);
}
;
;
exports.scrollTo = function (params) {
    var containerElementClientHeight = params.containerElement.clientHeight;
    var containerElementScrollTop = params.containerElement.scrollTop;
    var targetElementOffsetTop = params.targetElement.offsetTop;
    var targetElementScrollHeight = params.targetElement.scrollHeight;
    if (params.center) {
        params.containerElement.scrollTop =
            targetElementOffsetTop
                - containerElementClientHeight / 2
                + targetElementScrollHeight / 2;
    }
    else {
        var containerBottom = containerElementScrollTop + containerElementClientHeight;
        var valueBottom = targetElementOffsetTop + targetElementScrollHeight;
        if (valueBottom > containerBottom) {
            params.containerElement.scrollTop = valueBottom - containerElementClientHeight;
        }
        else if (targetElementOffsetTop < containerElementScrollTop) {
            params.containerElement.scrollTop = targetElementOffsetTop;
        }
    }
};
function filterRegions(regions, filterPhrase) {
    var filteredRegions = [];
    if (!filterPhrase || filterPhrase.length === 0) {
        return regions;
    }
    for (var i = 0; i < regions.length; i++) {
        var regionGroupItems = regions[i][1].filter(function (region) {
            var regionTitle = normalizeString(region.displayName);
            return regionTitle.indexOf(normalizeString(filterPhrase)) !== -1;
        });
        if (regionGroupItems.length > 0) {
            var regionGroup = [];
            regionGroup[0] = regions[i][0];
            regionGroup[1] = regionGroupItems;
            filteredRegions.push(regionGroup);
        }
    }
    return filteredRegions;
}
exports.filterRegions = filterRegions;
function normalizeString(input) {
    return input
        .toLowerCase()
        .replace(new RegExp('ё', 'g'), 'е')
        .replace(new RegExp('й', 'g'), 'и');
}


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(1);
var React = __webpack_require__(0);
var events_1 = __webpack_require__(6);
var text_field_1 = __webpack_require__(4);
var popup_content_1 = __webpack_require__(32);
var popup_1 = __webpack_require__(5);
var addSuggestionIndex = function (suggestions) {
    return suggestions.map(function (suggestion, index) { return ({
        label: suggestion.label,
        meta: suggestion.meta,
        value: suggestion.value || suggestion.label + "_" + index,
    }); });
};
var TypeaheadField = /** @class */ (function (_super) {
    tslib_1.__extends(TypeaheadField, _super);
    function TypeaheadField(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            focused: false,
            selectedIndex: null,
        };
        _this.textField = null;
        _this.popupContent = null;
        _this.suggestions = addSuggestionIndex(props.suggestions);
        return _this;
    }
    TypeaheadField.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.suggestions !== nextProps.suggestions) {
            this.suggestions = addSuggestionIndex(nextProps.suggestions);
            this.setState({
                selectedIndex: null,
            });
        }
    };
    TypeaheadField.prototype.focus = function () {
        if (this.textField) {
            this.textField.focus();
        }
    };
    TypeaheadField.prototype.blur = function () {
        if (this.textField) {
            this.textField.blur();
        }
    };
    TypeaheadField.prototype.render = function () {
        var _this = this;
        var values = this.suggestions
            .map(function (suggestion) { return ({
            label: suggestion.label,
            value: suggestion.value,
        }); });
        var selectedIndex = this.state.selectedIndex;
        var selectedValue = typeof selectedIndex === 'number' ? values[selectedIndex] : null;
        return (React.createElement("div", null,
            React.createElement(text_field_1.default, tslib_1.__assign({}, this.props, { ref: function (textField) { return _this.textField = textField; }, value: this.props.value, onValueChange: this.handleValueChange.bind(this), onFocus: this.handleFocus.bind(this), onBlur: this.handleBlur.bind(this), onKeyDown: this.handleKeyDown.bind(this) })),
            this.state.focused && (this.props.notFoundVisible || this.props.suggestions.length > 0) &&
                React.createElement(popup_1.default, { containerStyle: [{ marginTop: 8 }, this.props.popupContainerStyle] },
                    React.createElement(popup_content_1.default, { ref: function (popupContent) { return _this.popupContent = popupContent; }, value: null, selectedValue: [selectedValue], values: values, onValueClick: function (value) { return _this.handleValueClick(value.value); }, onValueMouseOver: function (value) { return _this.handleValueMouseMove(value.value); }, containerStyle: this.props.popupContentContainerStyle, valueStyle: [{
                                paddingLeft: 16,
                                paddingRight: 16,
                                minWidth: 300,
                                textOverflow: 'ellipsis',
                                overflow: 'hidden',
                                whiteSpace: 'nowrap',
                            }, this.props.popupContentValueStyle] }))));
    };
    TypeaheadField.prototype.handleValueClick = function (value) {
        var suggIndex = this.suggestions.findIndex(function (s) { return s.value === value; });
        if (suggIndex >= 0) {
            this.handleSuggestionSelect(this.props.suggestions[suggIndex]);
        }
    };
    TypeaheadField.prototype.handleValueMouseMove = function (value) {
        var selectedIndex = this.suggestions.findIndex(function (s) { return s.value === value; });
        this.setState({ selectedIndex: selectedIndex });
    };
    TypeaheadField.prototype.handleFocus = function (event) {
        if (this.props.onFocus) {
            this.props.onFocus(event);
        }
        this.setState({
            focused: true,
            selectedIndex: null,
        });
    };
    TypeaheadField.prototype.handleKeyDown = function (event) {
        var nativeEvent = event.nativeEvent;
        var code = events_1.getKeyboardEventCode(nativeEvent);
        switch (code) {
            case 'ArrowDown':
            case 'Down':
                event.preventDefault();
                this.incrementSelectedIndex();
                break;
            case 'ArrowUp':
            case 'Up':
                event.preventDefault();
                this.decrementSelectedIndex();
                break;
            case 'Tab':
            case 'NumpadEnter':
            case 'Enter':
                if (this.state.selectedIndex !== null) {
                    event.preventDefault();
                    this.handleSuggestionSelect(this.props.suggestions[this.state.selectedIndex]);
                }
                else if (this.props.suggestions.length > 0) {
                    event.preventDefault();
                    this.handleSuggestionSelect(this.props.suggestions[0]);
                }
                break;
            default:
                break;
        }
    };
    TypeaheadField.prototype.handleValueChange = function (value) {
        this.props.onValueChange(value);
        this.setState({
            focused: true,
            selectedIndex: null,
        });
    };
    TypeaheadField.prototype.handleBlur = function (event) {
        var _this = this;
        if (this.props.onBlur) {
            this.props.onBlur(event);
        }
        setTimeout(function () {
            _this.setState({
                focused: false,
                selectedIndex: null,
            });
        }, 50);
    };
    TypeaheadField.prototype.incrementSelectedIndex = function () {
        var selectedIndex = this.state.selectedIndex === null
            ? 0
            : this.state.selectedIndex + 1;
        if (selectedIndex >= this.props.suggestions.length) {
            selectedIndex = null;
        }
        this.setState({
            selectedIndex: selectedIndex,
        });
        if (typeof selectedIndex === 'number' && this.popupContent && this.popupContent.scrollTo) {
            this.popupContent.scrollTo(selectedIndex);
        }
    };
    TypeaheadField.prototype.decrementSelectedIndex = function () {
        var selectedIndex = this.state.selectedIndex === null
            ? this.props.suggestions.length - 1
            : this.state.selectedIndex - 1;
        if (selectedIndex < 0) {
            selectedIndex = null;
        }
        this.setState({
            selectedIndex: selectedIndex,
        });
        if (typeof selectedIndex === 'number' && this.popupContent && this.popupContent.scrollTo) {
            this.popupContent.scrollTo(selectedIndex);
        }
    };
    TypeaheadField.prototype.handleSuggestionSelect = function (suggestion) {
        this.props.onValueChange(suggestion.label, true);
        if (this.props.onSuggestionSelect) {
            this.props.onSuggestionSelect(suggestion);
        }
    };
    TypeaheadField.defaultProps = {
        notFoundVisible: false,
    };
    return TypeaheadField;
}(React.Component));
exports.default = TypeaheadField;


/***/ }),
/* 16 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"components-container-jh7lmvfzHi8","label":"components-label-ewnjEqK2Agk","mobile":"components-mobile-5aiSioLFY4S","checked":"components-checked-ikJtYK1JE48","invalid":"components-invalid-1PfqLc1jE0A","disabled":"components-disabled-7fL22OE7ksq","required":"components-required-1dJnjZ4fpqC"};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(1);
var utils_1 = __webpack_require__(2);
var React = __webpack_require__(0);
var scroll_to_1 = __webpack_require__(33);
var styles = __webpack_require__(34);
var AbstractPopupContent = /** @class */ (function (_super) {
    tslib_1.__extends(AbstractPopupContent, _super);
    function AbstractPopupContent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.container = null;
        _this.values = [];
        _this.mouseOverDisabled = false;
        return _this;
    }
    AbstractPopupContent.prototype.render = function () {
        var _this = this;
        // массив ref'ов
        this.values = [];
        return (React.createElement("div", tslib_1.__assign({ ref: function (container) { return _this.container = container; } }, utils_1.mergeStyles(styles['values'], this.props.containerStyle)), this.props.multiple ? this.renderItemsForMultipleChoices() : this.renderItemsForSingleChoice()));
    };
    AbstractPopupContent.prototype.scrollTo = function (index, center) {
        var _this = this;
        if (center === void 0) { center = false; }
        var containerElement = this.container;
        var valueElement = this.values[index];
        if (!valueElement || !containerElement) {
            return;
        }
        window.clearTimeout(this.timeout);
        this.mouseOverDisabled = true;
        scroll_to_1.scrollTo({ center: center, containerElement: containerElement, targetElement: valueElement });
        this.timeout = window.setTimeout(function () {
            _this.mouseOverDisabled = false;
        }, 100);
    };
    AbstractPopupContent.prototype.handleValueMouseOver = function (cb) {
        if (this.mouseOverDisabled) {
            window.clearTimeout(this.timeout);
            this.mouseOverDisabled = false;
            return;
        }
        cb();
    };
    return AbstractPopupContent;
}(React.Component));
exports.AbstractPopupContent = AbstractPopupContent;


/***/ }),
/* 18 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"value":"components-value-e9gY9E7kYwi","value-checkbox":"components-value-checkbox-6TpNUUDXnU8","value-selected":"components-value-selected-de9NCwI3UAA","value-active":"components-value-active-5xamnzmgBGS"};

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(1);
var React = __webpack_require__(0);
var utils_1 = __webpack_require__(2);
var styles = __webpack_require__(39);
var ButtonCollapsedTheme;
(function (ButtonCollapsedTheme) {
    ButtonCollapsedTheme[ButtonCollapsedTheme["BLACK"] = 0] = "BLACK";
    ButtonCollapsedTheme[ButtonCollapsedTheme["BLUE"] = 1] = "BLUE";
})(ButtonCollapsedTheme = exports.ButtonCollapsedTheme || (exports.ButtonCollapsedTheme = {}));
var ButtonCollapsed = /** @class */ (function (_super) {
    tslib_1.__extends(ButtonCollapsed, _super);
    function ButtonCollapsed() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ButtonCollapsed.prototype.render = function () {
        var _a = this.props, buttonText = _a.buttonText, closeButtonText = _a.closeButtonText, onClick = _a.onClick, opened = _a.opened, buttonStyle = _a.buttonStyle, buttonInnerStyle = _a.buttonInnerStyle, theme = _a.theme, arrow = _a.arrow;
        var buttonStyles = utils_1.mergeStyles(styles['button'], theme === ButtonCollapsedTheme.BLACK && styles['themeBlack'], theme === ButtonCollapsedTheme.BLUE && styles['themeBlue'], arrow && styles['arrow'], opened && styles['opened'], buttonStyle);
        var buttonInnerStyles = utils_1.mergeStyles(styles['buttonInner'], buttonInnerStyle);
        return (React.createElement("button", tslib_1.__assign({ onClick: onClick }, buttonStyles),
            React.createElement("span", tslib_1.__assign({}, buttonInnerStyles), opened ? closeButtonText : buttonText)));
    };
    ButtonCollapsed.defaultProps = {
        arrow: true,
        opened: false,
        buttonText: 'Читать полностью',
        closeButtonText: 'Скрыть',
        theme: ButtonCollapsedTheme.BLUE,
    };
    return ButtonCollapsed;
}(React.Component));
exports.default = ButtonCollapsed;


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var outside_click_component_1 = __webpack_require__(51);
exports.OutsideClick = outside_click_component_1.OutsideClick;
exports.default = outside_click_component_1.OutsideClick;


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(1);
var React = __webpack_require__(0);
/**
 * Компонент используемый как обертка для SVG элементов, если известен лишь один из размеров.
 * Сделано специально для IE10+ (включая Edge), т.к. они не умеют нормально масштабировать SVG.
 */
var SvgScalable = /** @class */ (function (_super) {
    tslib_1.__extends(SvgScalable, _super);
    function SvgScalable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.element = null;
        _this.enabled = false;
        return _this;
    }
    SvgScalable.prototype.componentWillMount = function () {
        if (typeof this.props.width === 'undefined' && typeof this.props.height === 'undefined') {
            throw new Error('Either width or height should be set');
        }
    };
    SvgScalable.prototype.componentDidMount = function () {
        this.enabled = isIE();
        if (!this.enabled) {
            return;
        }
        this.updateSizes();
    };
    SvgScalable.prototype.componentDidUpdate = function () {
        if (!this.enabled) {
            return;
        }
        this.updateSizes();
    };
    SvgScalable.prototype.render = function () {
        var _this = this;
        return (React.createElement("svg", tslib_1.__assign({ ref: function (element) { return _this.element = element; } }, this.props), this.props.children));
    };
    SvgScalable.prototype.updateSizes = function () {
        if (this.element && (typeof this.props.width === 'undefined' || typeof this.props.height === 'undefined')) {
            var boundingClientRect = this.element.getBoundingClientRect();
            var bBox = this.element.getBBox();
            if (typeof this.props.height !== 'undefined') {
                var height = boundingClientRect.height;
                var ratio = bBox.width / bBox.height;
                var width = height * ratio;
                this.element.setAttribute('width', "" + Math.round(width));
            }
            else {
                var width = boundingClientRect.width;
                var ratio = bBox.height / bBox.width;
                var height = width * ratio;
                this.element.setAttribute('height', "" + Math.round(height));
            }
        }
    };
    return SvgScalable;
}(React.Component));
exports.default = SvgScalable;
function isIE() {
    var ua = window.navigator.userAgent;
    if (ua.indexOf('MSIE ') > 0 || ua.indexOf('Trident/') > 0 || ua.indexOf('Edge/') > 0) {
        return true;
    }
    return false;
}


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(1);
var React = __webpack_require__(0);
// tslint:disable-next-line:no-any
function cloneReferencedElement(element, config) {
    var children = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        children[_i - 2] = arguments[_i];
    }
    var cloneRef = config.ref;
    var originalRef = element.ref;
    if (originalRef == null || cloneRef == null) {
        return React.cloneElement.apply(React, [element, config].concat(children));
    }
    if (typeof originalRef !== 'function') {
        if (process.env.NODE_ENV !== 'production') {
            console.warn('Cloning an element with a ref that will be overwritten because it ' +
                'is not a function. Use a composable callback-style ref instead. ' +
                'Ignoring ref: ' + originalRef);
        }
        return React.cloneElement.apply(React, [element, config].concat(children));
    }
    return React.cloneElement.apply(React, [element, tslib_1.__assign({}, config, { 
            // tslint:disable-next-line:no-any
            ref: function (component) {
                cloneRef(component);
                originalRef(component);
            } })].concat(children));
}
exports.cloneReferencedElement = cloneReferencedElement;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(66)))

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.throttle = function (fn, threshhold) {
    if (threshhold === void 0) { threshhold = 250; }
    var last;
    var deferTimer;
    return function () {
        var now = Date.now();
        if (last && now < last + threshhold) {
            // hold on to it
            clearTimeout(deferTimer);
            deferTimer = setTimeout(function () {
                last = now;
                fn();
            }, threshhold);
        }
        else {
            last = now;
            fn();
        }
    };
};


/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports = require("react-dom");

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(1);
var React = __webpack_require__(0);
var number_helpers_1 = __webpack_require__(26);
var text_field_1 = __webpack_require__(4);
var getTextValueFromProps = function (props) {
    if (props.disablePrettyFormating) {
        return props.value && String(props.value) || '';
    }
    return number_helpers_1.numberToPrettyString(props.value);
};
var getMaxLengthFromProps = function (props) {
    var _a = props.maxLength, maxLength = _a === void 0 ? 13 : _a, _b = props.maxFractionalLength, maxFractionalLength = _b === void 0 ? 2 : _b;
    var negativeCharLength = props.disableNegative ? 0 : 1;
    var fractionalLength = props.disableFractional ? 0 : 1 + maxFractionalLength;
    return negativeCharLength + maxLength + number_helpers_1.numberTrunc(maxLength / 3) + fractionalLength;
};
var NumberField = /** @class */ (function (_super) {
    tslib_1.__extends(NumberField, _super);
    function NumberField(props) {
        var _this = _super.call(this, props) || this;
        _this.textField = null;
        _this.focused = false;
        _this.isPreviousKeyDelimiter = false;
        _this.handleFocus = function (event) {
            if (_this.props.onFocus) {
                _this.props.onFocus(event);
            }
            _this.focused = true;
        };
        _this.state = {
            textValue: getTextValueFromProps(props),
            maxLength: getMaxLengthFromProps(props),
        };
        return _this;
    }
    NumberField.getDerivedStateFromProps = function (props) {
        return {
            textValue: getTextValueFromProps(props),
            maxLength: getMaxLengthFromProps(props),
        };
    };
    NumberField.prototype.componentDidUpdate = function () {
        if (this.textField && this.focused && typeof this.state.caretPosition !== 'undefined') {
            this.textField.setSelectionRange(this.state.caretPosition, this.state.caretPosition);
        }
    };
    NumberField.prototype.focus = function () {
        if (this.textField) {
            this.textField.focus();
        }
    };
    NumberField.prototype.render = function () {
        var _this = this;
        var type = this.props.type;
        var value = type === 'number' ?
            this.state.textValue.replace(/ /g, '') :
            this.state.textValue.replace(/\./, ',');
        return (React.createElement(text_field_1.default, tslib_1.__assign({}, this.props, { ref: function (textField) { return _this.textField = textField; }, value: value, onKeyDown: this.handleKeyDown.bind(this), onPaste: this.handlePaste.bind(this), onValueChange: this.handleValueChange.bind(this), onFocus: this.handleFocus, onBlur: this.handleBlur.bind(this), maxLength: this.state.maxLength })));
    };
    NumberField.prototype.handleKeyDown = function (event) {
        var textField = this.textField;
        if (!textField) {
            return;
        }
        var isPreviousKeyDelimiter = this.isPreviousKeyDelimiter;
        this.isPreviousKeyDelimiter = false;
        // backspace, delete, tab, escape, enter
        if ([46, 8, 9, 27, 13, 110].indexOf(event.keyCode) !== -1) {
            return;
        }
        // Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
        if ((event.keyCode === 65 || event.keyCode === 86 || event.keyCode === 67 || event.keyCode === 88) &&
            (event.ctrlKey === true || event.metaKey === true)) {
            return;
        }
        // home, end, left, right, down, up
        if (event.keyCode >= 35 && event.keyCode <= 40) {
            return;
        }
        if (['.', ',', 'б', 'ю'].indexOf(event.key) !== -1) {
            this.isPreviousKeyDelimiter = true;
            if (this.props.disableFractional) {
                event.preventDefault();
                return;
            }
            /**
             * Мы не можем узнать позицию каретки у input[type=number] и некоторых других в браузере Chrome
             * Просто запрещаем ввод запятой, если она уже есть
             */
            if (typeof textField.selectionStart === 'undefined') {
                if (this.state.textValue.length === 0 || this.state.textValue.indexOf('.') !== -1 || isPreviousKeyDelimiter) {
                    event.preventDefault();
                }
                return;
            }
            var valueAfterCut = [this.state.textValue.slice(0, Number(textField.selectionStart)),
                this.state.textValue.slice(Number(textField.selectionStart) +
                    (Number(textField.selectionEnd) - Number(textField.selectionStart)))].join('');
            if (valueAfterCut.length === 0 || valueAfterCut.indexOf('.') !== -1) {
                event.preventDefault();
            }
        }
        else if ((event.keyCode < 48 || event.keyCode > 57 && event.keyCode < 96 || event.keyCode > 105) &&
            event.keyCode !== 189) {
            this.isPreviousKeyDelimiter = isPreviousKeyDelimiter;
            event.preventDefault();
        }
    };
    NumberField.prototype.handlePaste = function (event) {
        if (!this.textField) {
            return;
        }
        var text = event.clipboardData.getData('text/plain');
        if (!/^[0-9\.\-,бю]+$/ig.test(text)) {
            event.preventDefault();
            return;
        }
        if (/^[\.,бю]+$/ig.test(text)) {
            if (typeof this.textField.selectionStart === 'undefined') {
                if (this.state.textValue.indexOf('.') !== -1 ||
                    this.isPreviousKeyDelimiter) {
                    event.preventDefault();
                }
                return;
            }
            var valueAfterCut = [this.state.textValue.slice(0, Number(this.textField.selectionStart)),
                this.state.textValue.slice(Number(this.textField.selectionStart) +
                    (Number(this.textField.selectionEnd) - Number(this.textField.selectionStart)))].join('');
            if (valueAfterCut.indexOf('.') !== -1) {
                event.preventDefault();
            }
            this.isPreviousKeyDelimiter = false;
        }
    };
    NumberField.prototype.handleValueChange = function (value) {
        if (!this.textField) {
            return;
        }
        var textValue = value
            .replace(/[,бю]/g, '.');
        var parsedNumber = number_helpers_1.parseNumber(textValue);
        var integerTrim = parsedNumber.integer.replace(/^0+(?!$)/, '');
        if (!this.props.disableFractional && parsedNumber.integer.startsWith('0') && integerTrim.length > 1) {
            parsedNumber = number_helpers_1.parseNumber(parsedNumber.sign + "0." + integerTrim);
            integerTrim = '0';
        }
        var newTextValue = [
            this.props.disableNegative ? '' : parsedNumber.sign,
            integerTrim.slice(0, this.props.maxLength),
            this.props.disableFractional || parsedNumber.fractional === null ? '' : '.',
            (parsedNumber.fractional || '').slice(0, this.props.maxFractionalLength),
        ].join('');
        var numberValue = newTextValue === ''
            ? undefined
            : number_helpers_1.stringToNumber(newTextValue);
        if (isNaN(numberValue)) {
            numberValue = undefined;
        }
        var newPrettyTextValue = newTextValue;
        if (typeof this.textField.selectionStart !== 'undefined') {
            if (typeof numberValue !== 'undefined') {
                var integer = number_helpers_1.numberTrunc(numberValue);
                if (!number_helpers_1.numberIsEgal(integer, -0)) {
                    newPrettyTextValue = this.props.disablePrettyFormating
                        ? integer && String(integer) || ''
                        : number_helpers_1.numberToPrettyString(integer);
                    if (!this.props.disableFractional && parsedNumber.fractional !== null) {
                        newPrettyTextValue += '.' + (parsedNumber.fractional || '').slice(0, this.props.maxFractionalLength);
                    }
                }
            }
            var caretPosition = Number(this.textField.selectionStart);
            var oldCaretPosition = caretPosition - (value.length - this.state.textValue.length);
            var newCaretPosition = oldCaretPosition + (newPrettyTextValue.length - this.state.textValue.length);
            if (oldCaretPosition === newCaretPosition && caretPosition < oldCaretPosition) {
                newCaretPosition = caretPosition;
            }
            this.props.onValueChange(numberValue);
            this.setState({
                textValue: newPrettyTextValue,
                caretPosition: newCaretPosition,
            });
        }
        else {
            this.props.onValueChange(numberValue);
            this.setState({
                textValue: newPrettyTextValue,
            });
        }
    };
    NumberField.prototype.handleBlur = function (event) {
        this.focused = false;
        if (this.props.onBlur) {
            this.props.onBlur(event);
        }
        var textValue = this.state.textValue
            .replace(/ /g, '');
        var _a = number_helpers_1.parseNumber(textValue), integer = _a.integer, fractional = _a.fractional;
        if (!integer && !fractional) {
            this.setState({
                textValue: '',
            });
            return;
        }
        var numberValue = number_helpers_1.stringToNumber(textValue);
        this.setState({
            textValue: this.props.disablePrettyFormating
                ? numberValue && String(numberValue) || ''
                : number_helpers_1.numberToPrettyString(numberValue),
        });
    };
    NumberField.defaultProps = {
        maxLength: 13,
        maxFractionalLength: 2,
    };
    return NumberField;
}(React.Component));
exports.default = NumberField;


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function reverseString(s) {
    return s.split('').reverse().join('');
}
function parseNumber(s) {
    var sign = s[0] === '-' ? '-' : '';
    var _a = s.split('.'), integer = _a[0], fractional = _a[1];
    return {
        sign: sign,
        integer: integer.replace(/[^0-9]/g, ''),
        fractional: fractional != null ? fractional.replace(/[^0-9]/g, '') : null,
    };
}
exports.parseNumber = parseNumber;
function numberToPrettyString(n) {
    if (typeof n !== 'number') {
        return '';
    }
    var _a = parseNumber(String(n)), sign = _a.sign, integer = _a.integer, fractional = _a.fractional;
    integer = reverseString(integer).match(/.{1,3}/g).reverse().map(reverseString).join(' ');
    if (!fractional) {
        return "" + sign + integer;
    }
    return "" + sign + integer + "." + fractional;
}
exports.numberToPrettyString = numberToPrettyString;
function numberToString(n) {
    return typeof n === 'number' ? String(n) : '';
}
exports.numberToString = numberToString;
function stringToNumber(s) {
    return Number(s);
}
exports.stringToNumber = stringToNumber;
function numberTrunc(value) {
    return value < 0 ? Math.ceil(value) : Math.floor(value);
}
exports.numberTrunc = numberTrunc;
function numberIsEgal(x, y) {
    if (x === y) {
        return x !== 0 || 1 / x === 1 / y;
    }
    return x !== x && y !== y;
}
exports.numberIsEgal = numberIsEgal;


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(1);
var React = __webpack_require__(0);
var react_dom_1 = __webpack_require__(24);
var throttle_1 = __webpack_require__(23);
var utils_1 = __webpack_require__(2);
var text_size_1 = __webpack_require__(28);
var element_helpers_1 = __webpack_require__(22);
var styles = __webpack_require__(90);
var TooltipPosition;
(function (TooltipPosition) {
    TooltipPosition[TooltipPosition["BOTTOM_LEFT"] = 0] = "BOTTOM_LEFT";
    TooltipPosition[TooltipPosition["RIGHT_CENTER"] = 1] = "RIGHT_CENTER";
    TooltipPosition[TooltipPosition["BOTTOM_WIDE"] = 2] = "BOTTOM_WIDE";
    TooltipPosition[TooltipPosition["BOTTOM_RIGHT"] = 3] = "BOTTOM_RIGHT";
    TooltipPosition[TooltipPosition["TOP_LEFT"] = 4] = "TOP_LEFT";
    TooltipPosition[TooltipPosition["TOP_RIGHT"] = 5] = "TOP_RIGHT";
})(TooltipPosition = exports.TooltipPosition || (exports.TooltipPosition = {}));
var Tooltip = /** @class */ (function (_super) {
    tslib_1.__extends(Tooltip, _super);
    function Tooltip() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.element = null;
        _this.state = {
            childrenWidth: null,
            childrenHeight: null,
            tooltipContentWidth: null,
        };
        return _this;
    }
    Tooltip.prototype.focus = function () {
        if (this.element && this.element.focus) {
            this.element.focus();
        }
    };
    Tooltip.prototype.componentDidMount = function () {
        var _this = this;
        this.textSizeCalculator = text_size_1.createTextSizeCalculator(styles['text_size_calculator']);
        this.recalculatePositionOnResize = throttle_1.throttle(function () {
            _this.calculatePosition();
        }, 50);
        this.calculatePosition();
        window.addEventListener('resize', this.recalculatePositionOnResize);
    };
    Tooltip.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.tooltipContent !== prevProps.tooltipContent) {
            this.calculatePosition();
        }
    };
    Tooltip.prototype.componentWillUnmount = function () {
        if (this.textSizeCalculator) {
            this.textSizeCalculator.detach();
        }
        if (this.recalculatePositionOnResize) {
            window.removeEventListener('resize', this.recalculatePositionOnResize);
        }
        this.textSizeCalculator = undefined;
        this.recalculatePositionOnResize = undefined;
    };
    Tooltip.prototype.render = function () {
        var _this = this;
        var _a = this.props, propsChildren = _a.children, tooltipStyles = _a.tooltipStyles, tooltipContent = _a.tooltipContent, arrow = _a.arrow, multiline = _a.multiline, thin = _a.thin;
        var childrenWidth = this.state.childrenWidth;
        var children = element_helpers_1.cloneReferencedElement(React.Children.only(propsChildren), { ref: function (element) { return _this.element = element; } });
        return (React.createElement("span", tslib_1.__assign({}, utils_1.mergeStyles(styles['wrapper'], tooltipStyles)),
            typeof childrenWidth === 'number' && childrenWidth > 0 && !!tooltipContent &&
                React.createElement("span", tslib_1.__assign({}, utils_1.mergeStyles(styles['container'], this.getContainerStyle())),
                    React.createElement("span", tslib_1.__assign({}, utils_1.mergeStyles(styles['block'], thin && styles['thin'], arrow && styles['arrow'], this.getTooltipStyle())),
                        React.createElement("span", tslib_1.__assign({}, utils_1.mergeStyles(styles['content'], multiline && styles['multiline'])), tooltipContent))),
            children));
    };
    Tooltip.prototype.getContainerStyle = function () {
        switch (this.props.position) {
            case TooltipPosition.RIGHT_CENTER:
                return [
                    styles['right_center'],
                    {
                        top: (this.state.childrenHeight || 0) / 2,
                        left: this.state.childrenWidth,
                    },
                ];
            case TooltipPosition.BOTTOM_WIDE:
                return [
                    styles['bottom_wide'],
                    {
                        top: this.state.childrenHeight,
                        left: 0,
                        right: 0,
                    },
                ];
            case TooltipPosition.BOTTOM_RIGHT:
                return [
                    styles['bottom_right'],
                    {
                        top: this.state.childrenHeight,
                        right: 0,
                    },
                ];
            case TooltipPosition.TOP_LEFT:
                return [
                    styles['top_left'],
                    {
                        bottom: this.state.childrenHeight,
                        left: 0,
                    },
                ];
            case TooltipPosition.TOP_RIGHT:
                return [
                    styles['top_right'],
                    {
                        bottom: this.state.childrenHeight,
                        right: 0,
                    },
                ];
            default:
                return [
                    styles['bottom_left'],
                    {
                        top: this.state.childrenHeight,
                    },
                ];
        }
    };
    Tooltip.prototype.getTooltipStyle = function () {
        if (this.props.position === TooltipPosition.BOTTOM_WIDE) {
            return styles['wide'];
        }
        return {
            width: this.state.tooltipContentWidth,
        };
    };
    Tooltip.prototype.calculatePosition = function () {
        var _this = this;
        var children = react_dom_1.findDOMNode(this).children;
        var childrenRect = children[children.length - 1].getBoundingClientRect();
        this.setState(function (_, props) {
            var state = {
                childrenWidth: childrenRect.width,
                childrenHeight: childrenRect.height,
                tooltipContentWidth: null,
            };
            if (_this.textSizeCalculator && props.tooltipContent) {
                state.tooltipContentWidth = _this.textSizeCalculator.calculate(props.tooltipContent);
            }
            return state;
        });
    };
    Tooltip.defaultProps = {
        position: TooltipPosition.BOTTOM_LEFT,
        arrow: true,
        multiline: false,
        thin: false,
    };
    return Tooltip;
}(React.Component));
exports.default = Tooltip;


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var sharedNode;
function getSharedNode() {
    if (!sharedNode) {
        sharedNode = window.document.createElement('div');
        sharedNode.style.position = 'fixed';
        sharedNode.style.top = '-1000px';
        sharedNode.style.visibility = 'hidden';
        sharedNode.style.width = 'auto';
        sharedNode.style.height = 'auto';
        sharedNode.style.whiteSpace = 'nowrap';
        sharedNode.style.zIndex = '-1';
        window.document.body.appendChild(sharedNode);
    }
    return sharedNode;
}
function createTextSizeCalculator(className) {
    var node = getSharedNode();
    return {
        calculate: function (text) {
            node.className = className;
            if (node.textContent !== text) {
                node.textContent = text;
            }
            return node.clientWidth + 1;
        },
        detach: function () { return undefined; },
    };
}
exports.createTextSizeCalculator = createTextSizeCalculator;


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable:max-line-length */
var async_typeahead_field_1 = __webpack_require__(30);
exports.AsyncTypeaheadField = async_typeahead_field_1.default;
var block_collapsed_1 = __webpack_require__(37);
exports.BlockCollapsed = block_collapsed_1.default;
var button_1 = __webpack_require__(8);
exports.Button = button_1.default;
var buttonLink_1 = __webpack_require__(7);
exports.ButtonTheme = buttonLink_1.ButtonTheme;
var button_checkbox_1 = __webpack_require__(42);
exports.ButtonCheckbox = button_checkbox_1.default;
var button_collapsed_1 = __webpack_require__(19);
exports.ButtonCollapsed = button_collapsed_1.default;
exports.ButtonCollapsedTheme = button_collapsed_1.ButtonCollapsedTheme;
var button_radio_group_field_1 = __webpack_require__(44);
exports.ButtonRadioGroupField = button_radio_group_field_1.default;
exports.ButtonRadioGroupFieldFit = button_radio_group_field_1.ButtonRadioGroupFieldFit;
var checkbox_field_1 = __webpack_require__(13);
exports.CheckboxField = checkbox_field_1.default;
var debug_1 = __webpack_require__(46);
exports.Debug = debug_1.default;
var dropdown_field_1 = __webpack_require__(48);
exports.DropdownField = dropdown_field_1.default;
var dropdown_field_link_1 = __webpack_require__(54);
exports.DropdownFieldLink = dropdown_field_link_1.default;
var dropdown_search_1 = __webpack_require__(56);
exports.DropdownSearch = dropdown_search_1.default;
var dropdown_search_field_1 = __webpack_require__(58);
exports.DropdownSearchField = dropdown_search_field_1.default;
var popup_content_1 = __webpack_require__(11);
exports.DropdownFieldPopupContent = popup_content_1.default;
var popup_content_search_1 = __webpack_require__(12);
exports.DropdownSearchPopupContent = popup_content_search_1.default;
exports.Delimiter = popup_content_search_1.Delimiter;
var image_none_1 = __webpack_require__(60);
exports.ImageNone = image_none_1.default;
var select_mobile_1 = __webpack_require__(63);
exports.SelectMobile = select_mobile_1.default;
var svg_scalable_1 = __webpack_require__(21);
exports.SvgScalable = svg_scalable_1.default;
var label_1 = __webpack_require__(65);
exports.Label = label_1.default;
var lazy_load_1 = __webpack_require__(68);
exports.LazyLoad = lazy_load_1.default;
var link_1 = __webpack_require__(71);
exports.Link = link_1.default;
var list_links_collapsed_1 = __webpack_require__(72);
exports.ListLinksCollapsed = list_links_collapsed_1.default;
var location_switcher_1 = __webpack_require__(74);
exports.LocationSwitcher = location_switcher_1.default;
var multiline_text_field_1 = __webpack_require__(76);
exports.MultilineTextField = multiline_text_field_1.default;
var number_field_1 = __webpack_require__(25);
exports.NumberField = number_field_1.default;
var outside_click_1 = __webpack_require__(20);
exports.OutsideClick = outside_click_1.default;
var password_field_1 = __webpack_require__(78);
exports.PasswordField = password_field_1.default;
var phone_field_1 = __webpack_require__(80);
exports.PhoneField = phone_field_1.default;
var popup_1 = __webpack_require__(5);
exports.Popup = popup_1.default;
exports.PopupArrow = popup_1.PopupArrow;
var popup_mobile_1 = __webpack_require__(82);
exports.PopupMobile = popup_mobile_1.default;
var preloader_1 = __webpack_require__(84);
exports.Preloader = preloader_1.default;
var radio_group_field_1 = __webpack_require__(86);
exports.RadioGroupField = radio_group_field_1.default;
var range_input_group_1 = __webpack_require__(88);
exports.RangeInputGroup = range_input_group_1.default;
var tag_1 = __webpack_require__(91);
exports.Tag = tag_1.default;
var tab_group_1 = __webpack_require__(93);
exports.TabGroup = tab_group_1.default;
var text_field_1 = __webpack_require__(4);
exports.TextField = text_field_1.default;
var tooltip_1 = __webpack_require__(27);
exports.Tooltip = tooltip_1.default;
exports.TooltipPosition = tooltip_1.TooltipPosition;
var typeahead_field_1 = __webpack_require__(15);
exports.TypeaheadField = typeahead_field_1.default;
var vertical_card_1 = __webpack_require__(95);
exports.VerticalCard = vertical_card_1.default;
var vertical_card_extended_1 = __webpack_require__(97);
exports.VerticalCardExtended = vertical_card_extended_1.default;
var style_1 = __webpack_require__(3);
exports.VisualSize = style_1.VisualSize;
exports.mergeStyles = style_1.mergeStyles;
var number_helpers_1 = __webpack_require__(26);
exports.numberToPrettyString = number_helpers_1.numberToPrettyString;
exports.numberToString = number_helpers_1.numberToString;
exports.stringToNumber = number_helpers_1.stringToNumber;
exports.parseNumber = number_helpers_1.parseNumber;
var events_1 = __webpack_require__(6);
exports.getKeyboardEventCode = events_1.getKeyboardEventCode;
var text_size_1 = __webpack_require__(28);
exports.createTextSizeCalculator = text_size_1.createTextSizeCalculator;
var modal_1 = __webpack_require__(99);
exports.Modal = modal_1.default;
var modal_wrapper_1 = __webpack_require__(101);
exports.ModalWrapper = modal_wrapper_1.default;
var location_offer_1 = __webpack_require__(103);
exports.LocationOffer = location_offer_1.default;


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(1);
var React = __webpack_require__(0);
var typeahead_field_1 = __webpack_require__(15);
var AsyncTypeaheadField = /** @class */ (function (_super) {
    tslib_1.__extends(AsyncTypeaheadField, _super);
    function AsyncTypeaheadField() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            suggestions: [],
        };
        _this.typeahead = null;
        _this.cache = new Map();
        return _this;
    }
    AsyncTypeaheadField.prototype.focus = function () {
        if (this.typeahead) {
            this.typeahead.focus();
        }
    };
    AsyncTypeaheadField.prototype.blur = function () {
        if (this.typeahead) {
            this.typeahead.blur();
        }
    };
    AsyncTypeaheadField.prototype.render = function () {
        var _this = this;
        return (React.createElement(typeahead_field_1.default, tslib_1.__assign({}, this.props, { ref: function (typeahead) { return _this.typeahead = typeahead; }, suggestions: this.state.suggestions, onFocus: this.handleFocus.bind(this), onValueChange: this.handleValueChange.bind(this), notFoundVisible: this.props.notFoundVisible })));
    };
    AsyncTypeaheadField.prototype.getQuery = function (value, cacheKeyPrefix) {
        return cacheKeyPrefix != null
            ? cacheKeyPrefix + value
            : value;
    };
    AsyncTypeaheadField.prototype.handleFocus = function (e) {
        if (this.props.onFocus) {
            this.props.onFocus(e);
        }
        if (this.props.value != null) {
            this.requestSuggestions(this.props.value);
        }
    };
    AsyncTypeaheadField.prototype.handleValueChange = function (value, onSelection) {
        this.props.onValueChange(value);
        if (value === '' || onSelection) {
            this.cancelCurrentRequest();
            this.setState({ suggestions: [] });
            return;
        }
        this.requestSuggestions(value);
    };
    AsyncTypeaheadField.prototype.cancelCurrentRequest = function () {
        if (this.currentRequest) {
            this.currentRequest.canceled = true;
        }
    };
    AsyncTypeaheadField.prototype.requestSuggestions = function (value) {
        var _this = this;
        this.cancelCurrentRequest();
        var query = this.getQuery(value, this.props.cacheKeyPrefix);
        if (this.cache.has(query)) {
            setTimeout(function () {
                _this.setState({
                    suggestions: _this.cache.get(query),
                });
            });
            return;
        }
        var currentRequest = {
            canceled: false,
            promise: this.props.requestSuggestions(value)
                .then(function (suggestions) {
                _this.cache.set(query, suggestions);
                if (!currentRequest.canceled) {
                    _this.setState({ suggestions: suggestions });
                }
            }),
        };
        this.currentRequest = currentRequest;
    };
    return AsyncTypeaheadField;
}(React.Component));
exports.default = AsyncTypeaheadField;


/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = require("@cian/text-field-component");

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(1);
var React = __webpack_require__(0);
var utils_1 = __webpack_require__(2);
var popup_content_search_1 = __webpack_require__(12);
var styles = __webpack_require__(18);
var PopupContent = /** @class */ (function (_super) {
    tslib_1.__extends(PopupContent, _super);
    function PopupContent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PopupContent.prototype.renderItemsForSingleChoice = function () {
        var _this = this;
        return (React.createElement("div", null,
            this.props.values.map(function (value, index) {
                var active = _this.props.value != null && _this.props.value.indexOf(value) >= 0;
                var selected = _this.props.selectedValue != null && _this.props.selectedValue.indexOf(value) >= 0;
                return (React.createElement("div", tslib_1.__assign({ key: value.value, ref: function (valueElement) { return _this.values[index] = valueElement; } }, utils_1.mergeStyles(styles['value'], active && styles['value-active'], active && _this.props.valueActiveStyle, selected && styles['value-selected'], selected && _this.props.valueSelectedStyle, _this.props.valueStyle), { onMouseOver: function () { return _this.handleValueMouseOver(function () { return _this.props.onValueMouseOver(value); }); }, onMouseDown: function (event) { return event.preventDefault(); }, onClick: function () { return _this.props.onValueClick(value); } }), value.label));
            }),
            this.props.values.length === 0 && this.renderNotFound()));
    };
    return PopupContent;
}(popup_content_search_1.default));
exports.default = PopupContent;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;
exports.scrollTo = function (params) {
    var containerElementClientHeight = params.containerElement.clientHeight;
    var containerElementScrollTop = params.containerElement.scrollTop;
    var targetElementOffsetTop = params.targetElement.offsetTop;
    var targetElementScrollHeight = params.targetElement.scrollHeight;
    if (params.center) {
        params.containerElement.scrollTop =
            targetElementOffsetTop
                - containerElementClientHeight / 2
                + targetElementScrollHeight / 2;
    }
    else {
        var containerBottom = containerElementScrollTop + containerElementClientHeight;
        var valueBottom = targetElementOffsetTop + targetElementScrollHeight;
        if (valueBottom > containerBottom) {
            params.containerElement.scrollTop = valueBottom - containerElementClientHeight;
        }
        else if (targetElementOffsetTop < containerElementScrollTop) {
            params.containerElement.scrollTop = targetElementOffsetTop;
        }
    }
};


/***/ }),
/* 34 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"values":"components-values-6Ek7OXnJ6wc"};

/***/ }),
/* 35 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"values":"components-values-ccBVxB6WPuM","container":"components-container-6wqGqqnU2co"};

/***/ }),
/* 36 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"components-container-5rZJYEyZFuG","arrow":"components-arrow-4WXq93BCaQ2","arrow-left":"components-arrow-left-d3ukUp2BOgO","arrow-center":"components-arrow-center-kJO3ueXvskm","arrow-right":"components-arrow-right-dEVal1JZiES"};

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(1);
var React = __webpack_require__(0);
var utils_1 = __webpack_require__(2);
var styles = __webpack_require__(38);
var button_collapsed_1 = __webpack_require__(19);
var BlockCollapsed = /** @class */ (function (_super) {
    tslib_1.__extends(BlockCollapsed, _super);
    function BlockCollapsed() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            opened: false,
        };
        _this.handleClick = function (event) {
            if (_this.props.onClick) {
                _this.props.onClick(event);
            }
            _this.setState({
                opened: !_this.state.opened,
            });
        };
        return _this;
    }
    BlockCollapsed.prototype.render = function () {
        var _a = this.props, buttonText = _a.buttonText, closeButtonText = _a.closeButtonText, children = _a.children, theme = _a.theme, toggleButtonHide = _a.toggleButtonHide, blockCollapsedStyles = _a.blockCollapsedStyles;
        var blockStyles = utils_1.mergeStyles(styles['blockCollapsed'], this.state.opened && styles['opened'], blockCollapsedStyles);
        var contentStyles = utils_1.mergeStyles(styles['content'], this.props.contentStyles);
        var buttonStyles = utils_1.mergeStyles(styles['button'], this.props.buttonStyles);
        return (React.createElement("div", tslib_1.__assign({}, blockStyles),
            React.createElement("div", tslib_1.__assign({}, contentStyles), children),
            !toggleButtonHide && React.createElement(button_collapsed_1.default, { buttonStyle: buttonStyles.className, buttonInnerStyle: this.props.buttonInnerStyles, theme: theme, buttonText: buttonText, closeButtonText: closeButtonText, opened: this.state.opened, onClick: this.handleClick })));
    };
    BlockCollapsed.defaultProps = {
        theme: button_collapsed_1.ButtonCollapsedTheme.BLACK,
        toggleButtonHide: false,
    };
    return BlockCollapsed;
}(React.Component));
exports.default = BlockCollapsed;


/***/ }),
/* 38 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"blockCollapsed":"components-blockCollapsed-3UQlgcMsd2M","button":"components-button-gmZJ0RmCHu8","opened":"components-opened-6WglF2SuPem","content":"components-content-g7wuq4V584s"};

/***/ }),
/* 39 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"button":"components-button-4pJ0WgzSWk2","buttonInner":"components-buttonInner-gBxbm5E6VGU","arrow":"components-arrow-1DQzAtPWW8C","themeBlack":"components-themeBlack-a6KX50VeTeu","opened":"components-opened-kv65tZqn9Qw"};

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;
exports.getValues = function (a) { return Object.keys(a).map(function (k) { return a[k]; }); };


/***/ }),
/* 41 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"components-container-hJ2fkNnJxQy","active":"components-active-ftbIqud6fKU","medium":"components-medium-2DrHCLEq7ym","large":"components-large-eEntMMYhoI2"};

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(1);
var React = __webpack_require__(0);
var utils_1 = __webpack_require__(2);
var styles = __webpack_require__(43);
__webpack_require__(9);
var ButtonCheckbox = /** @class */ (function (_super) {
    tslib_1.__extends(ButtonCheckbox, _super);
    function ButtonCheckbox() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChangeHandler = function (e) {
            var target = e.target;
            if (_this.props.onChange) {
                _this.props.onChange(e);
            }
            if (_this.props.onValueChange) {
                _this.props.onValueChange(target.checked);
            }
        };
        return _this;
    }
    ButtonCheckbox.prototype.render = function () {
        var _a = this.props, id = _a.id, children = _a.children, name = _a.name, checked = _a.checked, defaultChecked = _a.defaultChecked, disabled = _a.disabled, required = _a.required, wide = _a.wide, buttonCheckboxStyle = _a.buttonCheckboxStyle, mobile = _a.mobile;
        var inputStyles = utils_1.mergeStyles(styles['input'], mobile && styles['mobile']);
        return (React.createElement("div", tslib_1.__assign({}, utils_1.mergeStyles(styles['container'], wide && styles['wide'], buttonCheckboxStyle)),
            React.createElement("label", { className: styles['labelContainer'], htmlFor: id },
                React.createElement("input", tslib_1.__assign({}, inputStyles, { checked: checked, defaultChecked: defaultChecked, type: "checkbox", id: id, name: name, disabled: disabled, required: required, onChange: this.onChangeHandler })),
                React.createElement("div", { className: styles['label'] }, children))));
    };
    ButtonCheckbox.defaultProps = {
        wide: false,
    };
    return ButtonCheckbox;
}(React.Component));
exports.default = ButtonCheckbox;


/***/ }),
/* 43 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"components-container-eE8jHNm6ycw","label":"components-label-aWiPkXJp2oC","wide":"components-wide-7GQxDs8gDKc","labelContainer":"components-labelContainer-3zfk8rZhVuS","input":"components-input-k0DB1octq08","mobile":"components-mobile-3sCJYUgLRCS"};

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(1);
var React = __webpack_require__(0);
var react_1 = __webpack_require__(0);
var utils_1 = __webpack_require__(2);
var events_1 = __webpack_require__(6);
var styles = __webpack_require__(45);
var ButtonRadioGroupFieldFit;
(function (ButtonRadioGroupFieldFit) {
    ButtonRadioGroupFieldFit[ButtonRadioGroupFieldFit["CONTENT"] = 0] = "CONTENT";
    ButtonRadioGroupFieldFit[ButtonRadioGroupFieldFit["CONTAINER"] = 1] = "CONTAINER";
    ButtonRadioGroupFieldFit[ButtonRadioGroupFieldFit["CONTAINER_HEIGHT"] = 2] = "CONTAINER_HEIGHT";
})(ButtonRadioGroupFieldFit = exports.ButtonRadioGroupFieldFit || (exports.ButtonRadioGroupFieldFit = {}));
var ButtonRadioGroupField = /** @class */ (function (_super) {
    tslib_1.__extends(ButtonRadioGroupField, _super);
    function ButtonRadioGroupField() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.buttons = [];
        return _this;
    }
    ButtonRadioGroupField.prototype.focus = function () {
        var focusableButtonIndex = this.props.values.findIndex(function (value) { return !value.disabled; });
        if (focusableButtonIndex !== undefined && this.buttons[focusableButtonIndex]) {
            this.buttons[focusableButtonIndex].focus();
        }
    };
    ButtonRadioGroupField.prototype.render = function () {
        var _this = this;
        this.buttons = [];
        return (React.createElement("div", tslib_1.__assign({}, utils_1.mergeStyles(styles['container'], this.props.required && styles['required'], this.props.invalid && styles['invalid'], this.props.disabled && styles['disabled'], this.props.fit === ButtonRadioGroupFieldFit.CONTENT && styles['fit_content'], this.props.fit === ButtonRadioGroupFieldFit.CONTAINER && styles['fit_container'], this.props.fit === ButtonRadioGroupFieldFit.CONTAINER_HEIGHT && styles['fit_container_height'], this.props.containerStyle)), this.props.values.map(function (value, index) {
            var active = _this.props.value === value.value;
            var disabled = !!(_this.props.disabled || value.disabled);
            return (React.createElement("button", tslib_1.__assign({ type: "button", ref: function (button) { return _this.buttons[index] = button; }, key: value.value }, utils_1.mergeStyles(styles['value'], active && styles['value-active'], !active && styles['value-inactive'], active && _this.props.activeButtonStyle, disabled && _this.props.disabledButtonStyle, _this.props.buttonStyle), { disabled: disabled, onClick: function () { return _this.handleValueClick(value.value, disabled); }, onKeyDown: function (event) { return _this.handleKeyDown(index, event); } }), value.label));
        })));
    };
    ButtonRadioGroupField.prototype.handleKeyDown = function (index, event) {
        var nativeEvent = event.nativeEvent;
        var code = events_1.getKeyboardEventCode(nativeEvent);
        switch (code) {
            case 'ArrowLeft':
            case 'Left':
                event.preventDefault();
                while (--index > -1) {
                    if (this.props.values[index] && !this.props.values[index].disabled && this.buttons[index]) {
                        this.buttons[index].focus();
                        break;
                    }
                }
                break;
            case 'ArrowRight':
            case 'Right':
                event.preventDefault();
                while (index++ < this.props.values.length) {
                    if (this.props.values[index] && !this.props.values[index].disabled && this.buttons[index]) {
                        this.buttons[index].focus();
                        break;
                    }
                }
                break;
            default:
                break;
        }
    };
    ButtonRadioGroupField.prototype.handleValueClick = function (value, disabled) {
        if (this.props.disabled || disabled) {
            return;
        }
        this.props.onValueChange(this.props.uncheckable && value === this.props.value
            ? this.props.emptyValue
            : value);
    };
    ButtonRadioGroupField.defaultProps = {
        fit: ButtonRadioGroupFieldFit.CONTENT,
    };
    return ButtonRadioGroupField;
}(react_1.Component));
exports.default = ButtonRadioGroupField;


/***/ }),
/* 45 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"components-container-45k7eoGQTmm","value":"components-value-65seKkgL6gc","required":"components-required-3mIdRtFvgQG","value-active":"components-value-active-Aan6tutzFI","invalid":"components-invalid-5XNfPJlTfU8","fit_container":"components-fit_container-ghxuD5ypJmG","fit_content":"components-fit_content-kIAv6U3CjA8","fit_container_height":"components-fit_container_height-5ZhXj3Fa1OQ"};

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(1);
var React = __webpack_require__(0);
var styles = __webpack_require__(47);
var Debug = /** @class */ (function (_super) {
    tslib_1.__extends(Debug, _super);
    function Debug() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Debug.prototype.render = function () {
        if (!this.props.force && window.localStorage.getItem('debug') !== 'cian') {
            return null;
        }
        return (React.createElement("div", { className: styles['container'] },
            this.props.title &&
                React.createElement("div", { className: styles['title'] }, this.props.title),
            React.createElement("pre", { className: styles['value'] }, JSON.stringify(this.props.value, null, 2))));
    };
    return Debug;
}(React.Component));
exports.default = Debug;


/***/ }),
/* 47 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"components-container-yL43qXu4G4","title":"components-title-2hOIUJxwcYm","value":"components-value-dQjh8NQuvQM"};

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(1);
var React = __webpack_require__(0);
var utils_1 = __webpack_require__(2);
var button_1 = __webpack_require__(8);
var buttonLink_1 = __webpack_require__(7);
var dropdown_1 = __webpack_require__(10);
var popup_1 = __webpack_require__(5);
var popup_content_1 = __webpack_require__(11);
var styles = __webpack_require__(53);
var DropdownField = /** @class */ (function (_super) {
    tslib_1.__extends(DropdownField, _super);
    function DropdownField() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DropdownField.prototype.renderButton = function (selectedLabel) {
        var _this = this;
        return (React.createElement(button_1.default, { ref: function (button) { return _this.button = button; }, theme: this.state.opened ? buttonLink_1.ButtonTheme.TOGGLE_ACTIVE : this.props.theme, buttonStyle: utils_1.mergeStyles(styles['button'], this.state.opened && styles['button--opened'], this.props.invalid && styles['button--invalid'], this.props.buttonStyle), onClick: function () { return _this.toggleOpened(); }, onKeyDown: function (event) { return _this.handleKeyDown(event); }, dataMark: this.props.dataMark }, this.props.label || selectedLabel));
    };
    DropdownField.prototype.renderPopup = function (_a) {
        var _this = this;
        var activeValue = _a.activeValue, selectedValue = _a.selectedValue;
        return (React.createElement(popup_1.default, { arrow: popup_1.PopupArrow.LEFT, containerStyle: [
                {
                    marginTop: 13,
                },
                this.props.popupStyle,
            ] },
            React.createElement(popup_content_1.default, { multiple: this.props.multiple, containerStyle: this.props.popupContentStyle, valueStyle: this.props.valueStyle, valueActiveStyle: this.props.valueActiveStyle, valueSelectedStyle: this.props.valueSelectedStyle, ref: function (popupContent) { return _this.popupContent = popupContent; }, value: activeValue, values: this.props.values, selectedValue: selectedValue, onValueClick: function (value) { return _this.handleValueClick(value); }, onValueMouseOver: function (value) { return _this.handleValueMouseOver(value); } })));
    };
    DropdownField.defaultProps = {
        theme: buttonLink_1.ButtonTheme.TOGGLE,
        multiple: false,
    };
    return DropdownField;
}(dropdown_1.AbstractDropdown));
exports.default = DropdownField;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.debounce = function (func, wait) {
    var timeout;
    return function () {
        var later = function () {
            timeout = null;
            func();
        };
        var callNow = !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) {
            func();
        }
        ;
    };
};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.startsWith = function (source, target) {
    return source.indexOf(target) === 0;
};


/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports = require("@cian/outside-click-component");

/***/ }),
/* 52 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"components-container-dl7iBWssVy8","required":"components-required-e11maHpF60G","placeholder":"components-placeholder-jQ2cK1Bq3QO","opened":"components-opened-gwW6JEzUisE","placeholder-opened":"components-placeholder-opened-7vHEvpYbJuS"};

/***/ }),
/* 53 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"button":"components-button-jZS4SpN1IcK","button--opened":"components-button--opened-8aRSpB0i1qI","button--invalid":"components-button--invalid-9ltPWCkVlmI"};

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(1);
var React = __webpack_require__(0);
var dropdown_1 = __webpack_require__(10);
var popup_1 = __webpack_require__(5);
var popup_content_1 = __webpack_require__(11);
var utils_1 = __webpack_require__(2);
var styles = __webpack_require__(55);
var DropdownFieldLink = /** @class */ (function (_super) {
    tslib_1.__extends(DropdownFieldLink, _super);
    function DropdownFieldLink() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DropdownFieldLink.prototype.renderButton = function (selectedLabel) {
        var _this = this;
        return (React.createElement("span", tslib_1.__assign({ ref: function (button) { return _this.button = button; } }, utils_1.mergeStyles([styles['link'], this.props.buttonStyle]), { onClick: function () { return _this.toggleOpened(); }, onKeyDown: function (event) { return _this.handleKeyDown(event); } }), this.props.label || selectedLabel));
    };
    DropdownFieldLink.prototype.renderPopup = function (_a) {
        var _this = this;
        var activeValue = _a.activeValue, selectedValue = _a.selectedValue;
        return (React.createElement(popup_1.default, { arrow: popup_1.PopupArrow.CENTER, containerStyle: [
                styles['container'],
                this.props.popupStyle,
            ] },
            React.createElement(popup_content_1.default, { multiple: this.props.multiple, containerStyle: this.props.popupContentStyle, valueStyle: this.props.valueStyle, valueActiveStyle: this.props.valueActiveStyle, valueSelectedStyle: this.props.valueSelectedStyle, ref: function (popupContent) { return _this.popupContent = popupContent; }, value: activeValue, values: this.props.values, selectedValue: selectedValue, onValueClick: function (value) { return _this.handleValueClick(value); }, onValueMouseOver: function (value) { return _this.handleValueMouseOver(value); } })));
    };
    return DropdownFieldLink;
}(dropdown_1.AbstractDropdown));
exports.default = DropdownFieldLink;


/***/ }),
/* 55 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"components-container-kic6Pdds8og","link":"components-link-az8hgvCYFMI"};

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(1);
var React = __webpack_require__(0);
var utils_1 = __webpack_require__(2);
var dropdown_1 = __webpack_require__(10);
var popup_1 = __webpack_require__(5);
var popup_content_search_1 = __webpack_require__(12);
var text_field_1 = __webpack_require__(4);
var styles = __webpack_require__(57);
var DropdownSearch = /** @class */ (function (_super) {
    tslib_1.__extends(DropdownSearch, _super);
    function DropdownSearch() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DropdownSearch.prototype.renderButton = function () {
        var _this = this;
        return (React.createElement("div", { className: styles['search'] },
            React.createElement(text_field_1.default, { ref: function (button) { return _this.button = button; }, onFocus: function () { return _this.focus(); }, placeholder: this.props.placeholder, onValueChange: function (searchValue) { return _this.setState({ searchValue: searchValue }); }, value: this.props.label ? this.props.label : this.state.searchValue, inputStyle: [
                    styles['search_input'],
                    this.props.inputStyle,
                ], containerStyle: [
                    styles['search'],
                    this.props.inputContainerStyle,
                ] }),
            React.createElement("span", tslib_1.__assign({}, utils_1.mergeStyles(styles['search_input_icon'], this.state.opened && styles['search_input_icon--opened'], this.props.invalid && styles['search_input_icon--invalid']), { onClick: function () { return _this.state.opened ? _this.blur() : _this.focus(); } }))));
    };
    DropdownSearch.prototype.renderPopup = function (_a) {
        var _this = this;
        var activeValue = _a.activeValue, selectedValue = _a.selectedValue;
        var values = this.matchValues(this.props.values);
        return (React.createElement(popup_1.default, { arrow: this.props.popupArrow, containerStyle: [styles['popup'], this.props.popupStyle] },
            React.createElement(popup_content_search_1.default, { multiple: this.props.multiple, containerStyle: [styles['container'], this.props.popupContentStyle], valueStyle: [styles['item'], this.props.valueStyle], valueActiveStyle: this.props.valueActiveStyle, valueSelectedStyle: this.props.valueSelectedStyle, delimiterStyle: [
                    styles['delimiter'],
                    this.props.delimiterStyle,
                ], ref: function (popupContent) { return _this.popupContent = popupContent; }, value: activeValue, values: values, selectedValue: selectedValue, onValueClick: function (value) { return _this.handleValueClick(value, values.length); }, onValueMouseOver: function (value) { return _this.handleValueMouseOver(value); } })));
    };
    DropdownSearch.prototype.close = function () {
        this.setState({ searchValue: '' });
        _super.prototype.close.call(this);
    };
    DropdownSearch.prototype.handleValueClick = function (value, searchValueCount) {
        if (this.props.multiple) {
            var changedValue = this.props.value;
            var valueIndex = changedValue.indexOf(value.value);
            if (valueIndex >= 0) {
                changedValue.splice(valueIndex, 1);
            }
            else {
                changedValue.push(value.value);
            }
            this.props.onValueChange(changedValue);
            if (searchValueCount === 1) {
                this.close();
            }
        }
        else {
            this.props.onValueChange(value.value);
            this.close();
        }
    };
    DropdownSearch.prototype.matchValues = function (values) {
        if (this.props.matchValues) {
            return this.props.matchValues(values);
        }
        var pattern = new RegExp(this.state.searchValue, 'ig');
        return values.filter(function (value) { return pattern.test(value.label); });
    };
    DropdownSearch.defaultProps = {
        multiple: true,
        popupArrow: popup_1.PopupArrow.NONE,
    };
    return DropdownSearch;
}(dropdown_1.AbstractDropdown));
exports.default = DropdownSearch;


/***/ }),
/* 57 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"values":"components-values-5e1IoilYBOw","popup":"components-popup-eDts87XXmEo","container":"components-container-lOHO998moCy","delimiter":"components-delimiter-fIjAenNNdeq","item":"components-item-esswXFcLNmC","search":"components-search-f36w9HhoysG","search_input_icon":"components-search_input_icon-aQ2Id8vSXmw","search_input_icon--opened":"components-search_input_icon--opened-geIDyp59V6I","search_input":"components-search_input-3Za6Kf03Es8"};

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(1);
var React = __webpack_require__(0);
var utils_1 = __webpack_require__(2);
var dropdown_1 = __webpack_require__(10);
var popup_1 = __webpack_require__(5);
var popup_content_1 = __webpack_require__(11);
var text_field_1 = __webpack_require__(4);
var styles = __webpack_require__(59);
var DropdownSearchField = /** @class */ (function (_super) {
    tslib_1.__extends(DropdownSearchField, _super);
    function DropdownSearchField() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            searchValue: '',
        };
        return _this;
    }
    DropdownSearchField.prototype.renderButton = function () {
        var _this = this;
        return (React.createElement("div", { className: styles['search'] },
            React.createElement(text_field_1.default, { ref: function (button) { return _this.button = button; }, onFocus: function () { return _this.focus(); }, placeholder: this.props.placeholder, onValueChange: function (searchValue) { return _this.setState({ searchValue: searchValue }); }, value: this.state.opened ? this.state.searchValue : (this.props.label || ''), inputStyle: [
                    styles['search_input'],
                    this.props.inputStyle,
                ], containerStyle: [
                    styles['search'],
                    this.props.inputContainerStyle,
                ] }),
            React.createElement("span", tslib_1.__assign({}, utils_1.mergeStyles(styles['search_input_icon'], this.state.opened && styles['search_input_icon--opened'], this.props.invalid && styles['search_input_icon--invalid']), { onClick: function () { return _this.state.opened ? _this.blur() : _this.focus(); } }))));
    };
    DropdownSearchField.prototype.renderPopup = function (_a) {
        var _this = this;
        var activeValue = _a.activeValue, selectedValue = _a.selectedValue;
        var values = this.matchValues(this.props.values);
        var content = (React.createElement(popup_content_1.default, { multiple: this.props.multiple, containerStyle: this.props.popupContentStyle, valueStyle: this.props.valueStyle, valueActiveStyle: this.props.valueActiveStyle, valueSelectedStyle: this.props.valueSelectedStyle, ref: function (popupContent) { return _this.popupContent = popupContent; }, value: activeValue, values: values, selectedValue: selectedValue, onValueClick: function (value) { return _this.handleValueClick(value); }, onValueMouseOver: function (value) { return _this.handleValueMouseOver(value); } }));
        return (React.createElement(popup_1.default, { arrow: this.props.popupArrow, containerStyle: [styles['popup'], this.props.popupStyle] }, values.length > 0 ? content : this.renderNotFound()));
    };
    DropdownSearchField.prototype.close = function () {
        this.setState({ searchValue: '' });
        _super.prototype.close.call(this);
    };
    DropdownSearchField.prototype.handleValueClick = function (value, _) {
        this.props.onValueChange(value.value);
        this.close();
    };
    DropdownSearchField.prototype.renderNotFound = function () {
        return (React.createElement("div", { className: styles['container'] }, this.props.valueNotFound ? this.props.valueNotFound : 'Ничего не найдено'));
    };
    DropdownSearchField.prototype.matchValues = function (values) {
        if (this.props.matchValues) {
            return this.props.matchValues(values);
        }
        var pattern = new RegExp(this.state.searchValue, 'ig');
        return values.filter(function (value) { return pattern.test(value.label); });
    };
    DropdownSearchField.defaultProps = {
        multiple: false,
        popupArrow: popup_1.PopupArrow.NONE,
    };
    return DropdownSearchField;
}(dropdown_1.AbstractDropdown));
exports.default = DropdownSearchField;


/***/ }),
/* 59 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"values":"components-values-gszzIovVn2c","popup":"components-popup-btmBGAZt5u2","container":"components-container-3lVz5BwGYMA","delimiter":"components-delimiter-jkxES5fgFUW","item":"components-item-9mE7bOBJq8Q","search":"components-search-b2sg8IKlTGi","search_input_icon":"components-search_input_icon-a2RryTr0qcu","search_input_icon--opened":"components-search_input_icon--opened-ccsTIotDsAA","search_input":"components-search_input-eBvW2HzSlUy"};

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(1);
var React = __webpack_require__(0);
var svg_scalable_1 = __webpack_require__(21);
var utils_1 = __webpack_require__(2);
var styles = __webpack_require__(61);
var baseCss = __webpack_require__(62);
var ImageNone = /** @class */ (function (_super) {
    tslib_1.__extends(ImageNone, _super);
    function ImageNone() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ImageNone.prototype.render = function () {
        return (React.createElement("div", tslib_1.__assign({}, utils_1.mergeStyles(styles['container'], this.props.containerStyle, { backgroundColor: this.props.bgColor })),
            React.createElement(svg_scalable_1.default, tslib_1.__assign({ viewBox: "0 0 157 208", height: "45%" }, utils_1.mergeStyles(styles['icon'], this.props.iconStyle)),
                React.createElement("g", { fill: this.props.iconColor },
                    React.createElement("path", { d: "M154.925 18.403L74.38.473c-1.39-.308-2.768.568-3.077 1.958L65.7 27.6l8.353-1.926 3.12-14.006c.308-1.39 1.688-2.266 3.078-1.957l65.45 14.57c1.39.31 2.27 1.69 1.96 3.08l-15.69 70.47c-.31 1.39-1.68 2.27-3.07 1.96l-24.96-5.55 4.5 19.49 24.09 5.36c1.39.31 2.77-.57 3.08-1.96l21.3-95.63c.31-1.39-.56-2.77-1.96-3.08z" }),
                    React.createElement("path", { d: "M119.955 37.925c-2.945-4.793-7.29-7.34-12.955-7.52-3.93-.125-7.398 1.198-10.315 3.73-2.485 2.157-4.096 4.742-4.838 7.715L99.1 73.292l.88 2.838c2.962-3.274 5.73-6.33 8.493-9.39 2.96-3.274 5.867-6.598 8.886-9.813 2.5-2.666 4.09-5.685 4.59-9.35.46-3.492-.2-6.718-2-9.652zm-6.447 9.512c-.93 4.05-4.603 5.945-8.324 5.278-3.74-.856-6.2-4.716-5.29-8.45.937-3.843 4.39-6.117 8.472-5.212 3.528.778 6.122 4.11 5.142 8.384zm-5.438 76.223L86.05 28.192c-.276-1.19-1.336-1.998-2.51-1.998-.19 0-.386.02-.582.067L2.55 44.81c-1.39.318-2.254 1.7-1.934 3.09l22.022 95.464c.273 1.195 1.336 2.002 2.51 2.002.192 0 .386-.023.582-.067l80.407-18.54c1.39-.33 2.253-1.71 1.934-3.1zm-13.527-12.755L29.21 125.97c-1.386.32-2.77-.544-3.09-1.934L9.89 53.694c-.32-1.39.547-2.772 1.934-3.094l65.33-15.065c1.388-.32 2.773.547 3.093 1.934l16.227 70.34c.32 1.38-.547 2.77-1.934 3.09z" }),
                    React.createElement("path", { d: "M48.263 59.36c4.3 2.68 8.664 5.395 13.314 8.288-.21-1.962-.714-3.535-1.057-5.133-.338-1.583-.722-3.156-1.104-4.81 3.497-.805 6.826-1.574 10.268-2.368.147.526.29.977.397 1.434.71 3.01 1.38 6.03 2.1 9.03.75 3.09 1.57 6.15 2.31 9.24.16.68.55 1.06 1.11 1.39 2.83 1.71 5.65 3.43 8.47 5.15.41.25.8.54 1.17.79-.26 1.06-6.23 10.82-8.28 13.6-1.35-.65-2.59-1.56-3.89-2.35-1.32-.8-2.62-1.63-3.93-2.45l-4.04-2.52c-1.31-.82-2.62-1.63-3.92-2.45l-3.93-2.45c-1.3-.82-2.61-1.63-4.02-2.51-1 1.26-1.72 2.63-2.54 3.91-.83 1.3-1.64 2.62-2.46 3.93L45.7 93.1c-.82 1.31-1.634 2.62-2.455 3.93l-2.454 3.93-2.37 3.784-13.25-8.28L48.3 59.388M22.52 175.86h-4.83v11.134H5.52v-11.14H.69v25.89h4.83V190.43h12.153v11.316h4.832v-25.89zm16.892 14.59h-8.34c.2-1.34.67-2.37 1.403-3.1s1.74-1.09 3.015-1.09c.657 0 1.233.11 1.728.33.493.22.902.52 1.224.902.32.38.562.828.723 1.335.16.506.24 1.05.24 1.62zm-8.43 2.664h11.36c.405 0 .68-.114.82-.35.14-.23.215-.68.215-1.35 0-1.324-.2-2.503-.6-3.535s-.95-1.91-1.655-2.62c-.706-.71-1.547-1.25-2.525-1.62-.978-.37-2.046-.55-3.203-.55-1.37 0-2.6.24-3.69.71-1.093.48-2.017 1.12-2.775 1.94-.76.82-1.34 1.78-1.75 2.88-.41 1.1-.61 2.28-.61 3.53 0 1.61.23 3.03.7 4.25.46 1.22 1.1 2.25 1.91 3.08.81.83 1.76 1.45 2.86 1.88 1.1.42 2.28.63 3.56.63.64 0 1.31-.05 1.99-.15.68-.1 1.36-.26 2.02-.49.66-.24 1.29-.55 1.9-.93.61-.39 1.16-.87 1.65-1.45l-1.27-1.61c-.18-.278-.46-.415-.83-.415-.28 0-.56.08-.85.25s-.63.35-1.02.554c-.39.2-.84.39-1.36.556-.52.17-1.14.25-1.85.25-.72 0-1.37-.11-1.96-.33-.59-.22-1.1-.553-1.53-1-.43-.445-.78-1.01-1.04-1.7-.27-.69-.43-1.5-.5-2.446zm31.46-6.46v-3.28H44.93v3.277h6.53v15.1h4.42v-15.09h6.552zm24.143 12.065v-12.34c1.777.13 3.152.73 4.124 1.8.97 1.06 1.45 2.52 1.45 4.37s-.49 3.3-1.46 4.37c-.97 1.06-2.35 1.66-4.13 1.79zm-3.87-12.34v12.33c-.884-.08-1.668-.26-2.354-.57-.68-.31-1.27-.72-1.75-1.24s-.85-1.14-1.1-1.88-.37-1.56-.37-2.48c0-.92.13-1.74.38-2.48.26-.73.62-1.36 1.11-1.89.49-.52 1.07-.94 1.76-1.24.69-.31 1.47-.49 2.35-.57zm4.007-3.28v-7.25H82.57v7.26c-1.47.08-2.808.36-4.02.83-1.21.47-2.25 1.11-3.115 1.92-.865.81-1.536 1.78-2.013 2.9-.478 1.12-.717 2.37-.717 3.76 0 1.39.24 2.66.716 3.78.48 1.13 1.15 2.1 2.02 2.91.87.81 1.91 1.45 3.12 1.93 1.21.47 2.55.76 4.02.84v5.91h4.15V202c1.47-.085 2.81-.365 4.02-.843 1.21-.477 2.25-1.122 3.12-1.934s1.53-1.783 2.01-2.91c.48-1.13.71-2.39.71-3.788 0-1.385-.24-2.638-.71-3.76-.48-1.122-1.15-2.09-2.01-2.9s-1.9-1.454-3.11-1.926c-1.21-.47-2.55-.75-4.02-.84zm21.313-.02c-1.372 0-2.62.22-3.74.66-1.122.44-2.08 1.06-2.872 1.88-.79.81-1.406 1.8-1.84 2.97-.438 1.17-.656 2.47-.656 3.92 0 1.45.218 2.77.653 3.94.435 1.17 1.05 2.16 1.843 2.99.792.82 1.75 1.45 2.87 1.89 1.123.44 2.37.66 3.74.66 1.36 0 2.6-.22 3.715-.67 1.116-.44 2.07-1.08 2.863-1.9.79-.82 1.4-1.82 1.83-2.99s.64-2.48.64-3.94c0-1.45-.21-2.75-.64-3.92-.43-1.17-1.04-2.17-1.83-2.98s-1.75-1.44-2.86-1.88c-1.11-.45-2.35-.67-3.71-.67zm0 15.52c-1.55 0-2.7-.52-3.445-1.55s-1.12-2.54-1.12-4.51c0-1.97.373-3.48 1.12-4.52s1.893-1.57 3.444-1.57c1.53 0 2.66.52 3.39 1.55.737 1.04 1.104 2.55 1.104 4.53s-.367 3.49-1.1 4.51c-.734 1.02-1.865 1.54-3.392 1.54zm28.187-11.96v-3.28h-17.51v3.27h6.53v15.09h4.42v-15.09h6.55zm10.73-3.57c-1.37 0-2.62.22-3.74.66-1.12.44-2.08 1.06-2.87 1.88s-1.406 1.8-1.84 2.97c-.436 1.17-.654 2.48-.654 3.92 0 1.45.216 2.77.65 3.94s1.05 2.16 1.843 2.99c.79.82 1.75 1.45 2.87 1.89 1.12.44 2.37.66 3.74.66 1.36 0 2.6-.22 3.72-.67 1.12-.45 2.07-1.08 2.86-1.9.8-.83 1.41-1.82 1.84-2.99.43-1.17.64-2.48.64-3.94 0-1.45-.21-2.75-.64-3.92-.43-1.17-1.04-2.17-1.83-2.98s-1.74-1.44-2.86-1.88c-1.11-.44-2.35-.66-3.71-.66zm0 15.52c-1.55 0-2.7-.52-3.442-1.55-.745-1.04-1.12-2.54-1.12-4.51 0-1.97.375-3.48 1.12-4.52.747-1.04 1.895-1.57 3.446-1.57 1.528 0 2.66.51 3.39 1.55.736 1.04 1.103 2.55 1.103 4.53s-.37 3.482-1.11 4.51c-.73 1.023-1.87 1.54-3.39 1.54z" })))));
    };
    ImageNone.defaultProps = {
        bgColor: baseCss['--cb-color-gray-3'],
        iconColor: baseCss['--cb-color-gray-2'],
    };
    return ImageNone;
}(React.Component));
exports.default = ImageNone;


/***/ }),
/* 61 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"components-container-fn11uqlg8SM","icon":"components-icon-822y7Een7Ou"};

/***/ }),
/* 62 */
/***/ (function(module, exports) {

module.exports = {
  // Colors
  '--cb-color-black': '#121212',
  '--cb-color-gray-1': '#7A7A7A',
  '--cb-color-gray-2': '#C9C9C9',
  '--cb-color-gray-3': '#E4E4E4',
  '--cb-color-gray-4': '#F4F4F4',
  '--cb-color-gray-5': '#D8D8D8',
  '--cb-color-white': '#FFFFFF',

  '--cb-color-main': '#2B87DB',
  '--cb-color-main-hover': '#256BA5',

  '--cb-color-gray': '#C9C9C9',
  '--cb-color-gray-hover': '#7A7A7A',

  '--cb-color-orange': '#FF9D00',
  '--cb-color-orange-hover': '#AF6800',

  '--cb-color-red': '#FF5050',
  '--cb-color-red-hover': '#B23939',

  '--cb-color-green': '#2E9E00',
  '--cb-color-green-hover': '#185100',

  '--cb-color-sand': '#FFF5D4',
  '--cb-color-sand-hover': '#FFEFBD',

  '--cb-color-popup_overlay': 'rgba(24, 41, 48, .8)',

  // Fonts
  '--cb-font-light': '300',
  '--cb-font-regular': '400',
  '--cb-font-semibold': '600',
  '--cb-font-bold': '700',
  '--cb-font-black': '900',
};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(1);
var React = __webpack_require__(0);
var styles = __webpack_require__(64);
__webpack_require__(9);
// tslint:disable-next-line:no-any
function isSelectMobileGroup(group) {
    return group.options !== undefined;
}
var SelectMobile = /** @class */ (function (_super) {
    tslib_1.__extends(SelectMobile, _super);
    function SelectMobile() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            selectedValues: '',
            values: [],
        };
        _this.renderOptions = function (option, index) {
            if (isSelectMobileGroup(option)) {
                return (React.createElement("optgroup", { className: styles['optgroup'], label: option.label, key: index }, option.options.map(_this.renderOption)));
            }
            else {
                return _this.renderOption(option);
            }
        };
        _this.renderOption = function (option) {
            return (React.createElement("option", { key: option.id, value: option.id, className: styles['option'] }, option.label));
        };
        _this.handleChange = function (event) {
            var allOptions = _this.collectAllOptions(_this.props);
            var target = event.target;
            // turns HTMLCollection to Array
            var options = Array.prototype.slice.call(target.options);
            var selectedIdsArray = [];
            var selectedValuesString = options.reduce(function (str, option) {
                if (option.selected) {
                    str = str.concat(option.text + ", ");
                    // finds and pushes selected element in array of all options
                    allOptions.forEach(function (allOption) {
                        // FIXME: какое-то легаси
                        if (allOption.id === option.value) {
                            selectedIdsArray.push(option.value);
                        }
                    });
                }
                return str;
            }, '').slice(0, -2); // cuts ', ' from the end
            if (_this.props.onValueChange) {
                _this.props.onValueChange(selectedIdsArray);
            }
            _this.setState({
                selectedValues: selectedValuesString,
            });
        };
        _this.collectAllOptions = function (props) {
            var allOptions = [];
            props.options.forEach(function (option) {
                isSelectMobileGroup(option) ?
                    allOptions = allOptions.concat(option.options) :
                    allOptions.push(option);
            });
            return allOptions;
        };
        // go through all options and looking for selected
        // to write them to defaultValue atribute
        _this.updateValuesState = function (props) {
            var allOptions = _this.collectAllOptions(props);
            var values = props.multiple ? [] : '';
            var reduced = false; // if (!multiple && selected options > 1) then select only first
            var selectedValuesString = allOptions.reduce(function (str, option) {
                // FIXME: какое-то легаси
                var isSelected = (!!props.value) && (props.value.indexOf(option.id) > -1);
                if (isSelected && !reduced) {
                    str = str.concat(option.label + ", ");
                    // Хак сделан потому, что для ts метод concat строки и массива разные.
                    // FIXME: какое-то легаси
                    values = values.concat(option.id);
                    if (!props.multiple) {
                        reduced = true;
                    }
                }
                return str;
            }, '').slice(0, -2); // cuts ', ' from the end
            _this.setState({
                selectedValues: selectedValuesString,
                values: values,
            });
        };
        return _this;
    }
    SelectMobile.prototype.componentWillMount = function () {
        this.updateValuesState(this.props);
    };
    SelectMobile.prototype.componentWillReceiveProps = function (nextProps) {
        this.updateValuesState(nextProps);
    };
    SelectMobile.prototype.render = function () {
        var _a = this.props, multiple = _a.multiple, options = _a.options, label = _a.label, id = _a.id, name = _a.name, onClick = _a.onClick;
        var labelText = this.state.selectedValues || label;
        return (React.createElement("div", { className: styles['selectMobile'] },
            React.createElement("label", { htmlFor: id, className: styles['label'], onClick: onClick },
                labelText,
                React.createElement("select", { value: this.state.values, className: styles['select'], id: id, name: name, multiple: multiple, onChange: this.handleChange },
                    React.createElement("optgroup", { disabled: true, hidden: true }),
                    options.map(this.renderOptions)))));
    };
    SelectMobile.defaultProps = {
        label: 'Выберите',
        options: [],
    };
    return SelectMobile;
}(React.Component));
exports.default = SelectMobile;


/***/ }),
/* 64 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"selectMobile":"components-selectMobile-9D1XXopBU4c","select":"components-select-1oFJMJnKLi8","optgroup":"components-optgroup-1EXw3obNis8","option":"components-option-5trhu5epFYi","label":"components-label-3LLcor8Bpuq"};

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(1);
var React = __webpack_require__(0);
var utils_1 = __webpack_require__(2);
var element_helpers_1 = __webpack_require__(22);
var styles = __webpack_require__(67);
var Label = /** @class */ (function (_super) {
    tslib_1.__extends(Label, _super);
    function Label() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.element = null;
        return _this;
    }
    Label.prototype.render = function () {
        var _this = this;
        var content = element_helpers_1.cloneReferencedElement(React.Children.only(this.props.children), { ref: function (element) { return _this.element = element; } });
        return (React.createElement("div", tslib_1.__assign({}, utils_1.mergeStyles(this.props.containerStyle)),
            React.createElement("div", tslib_1.__assign({}, utils_1.mergeStyles(this.props.labelWrapperStyle)),
                React.createElement("label", tslib_1.__assign({}, utils_1.mergeStyles(styles['label'], this.props.labelStyle), { onClick: function (event) { return _this.handleClick(event); } }), this.props.label)),
            React.createElement("div", tslib_1.__assign({}, utils_1.mergeStyles(styles['content_wrapper'], this.props.contentWrapperStyle)), content)));
    };
    Label.prototype.handleClick = function (event) {
        if (this.props.onClick) {
            this.props.onClick(event);
        }
        if (this.element && this.element.focus) {
            this.element.focus();
        }
    };
    return Label;
}(React.Component));
exports.default = Label;


/***/ }),
/* 66 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 67 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"label":"components-label-fjcOBw4hagC","content_wrapper":"components-content_wrapper-cyvLmDsmxqS"};

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(1);
var React = __webpack_require__(0);
var throttle_1 = __webpack_require__(23);
var events_1 = __webpack_require__(6);
var visibility_helper_1 = __webpack_require__(69);
// tslint:disable-next-line:no-any
var listeners = [];
function scheduleLowPriorityTask(cb) {
    // tslint:disable-next-line:no-any
    var r = window.requestIdleCallback;
    if (r) {
        r(cb, { timeout: 500 });
    }
    else {
        setTimeout(cb, 500);
    }
}
;
var lazyLoadHandler = function () {
    // tslint:disable-next-line:no-any
    var newListeners = [];
    for (var i = 0; i < listeners.length; ++i) {
        var listener = listeners[i];
        if (!visibility_helper_1.checkVisible(listener)) {
            newListeners.push(listener);
        }
    }
    listeners = newListeners;
};
var loadFirstListener = function () {
    var componentIndex = listeners.findIndex(function (listener) { return !!listener.props.deferred; });
    if (componentIndex !== -1) {
        var component = listeners.splice(componentIndex, 1)[0];
        component.visible = true;
        component.forceUpdate();
    }
    scheduleLowPriorityTask(loadFirstListener);
};
var initLazyLoad = function () {
    if ((typeof window === 'undefined') || (listeners)) {
        return;
    }
    listeners = [];
    var finalLazyLoadHandler = throttle_1.throttle(lazyLoadHandler, 300);
    events_1.on(window, 'scroll', finalLazyLoadHandler);
    events_1.on(window, 'resize', finalLazyLoadHandler);
    events_1.on(window, 'load', function () { return scheduleLowPriorityTask(loadFirstListener); });
};
var LazyLoad = /** @class */ (function (_super) {
    tslib_1.__extends(LazyLoad, _super);
    function LazyLoad() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.visible = false;
        _this.status = 'waiting';
        return _this;
    }
    LazyLoad.prototype.componentDidMount = function () {
        initLazyLoad();
        if (!visibility_helper_1.checkVisible(this)) {
            listeners.push(this);
        }
    };
    LazyLoad.prototype.componentWillUnmount = function () {
        var _this = this;
        listeners = listeners.filter(function (el) { return (el !== _this); });
    };
    LazyLoad.prototype.componentWillUpdate = function () {
        var _this = this;
        if ((this.visible) && (this.status === 'waiting')) {
            this.status = 'loading';
            this.content = this.props.onLoad();
            this.content.then(function (result) {
                _this.status = 'loaded';
                _this.loadResult = result;
                _this.forceUpdate();
            }).catch(function (e) {
                _this.status = 'error';
                _this.loadError = e;
                _this.forceUpdate();
            });
        }
    };
    LazyLoad.prototype.render = function () {
        switch (this.status) {
            case 'waiting':
                return (this.props.renderEmpty());
            case 'loading':
                if (this.props.renderLoading) {
                    return this.props.renderLoading();
                }
                return this.props.renderEmpty();
            case 'loaded':
                return (this.props.renderLoaded(this.loadResult));
            case 'error':
                if (this.props.renderError) {
                    return this.props.renderError(this.loadError);
                }
                return this.props.renderEmpty();
            default:
                return (this.props.renderEmpty());
        }
    };
    return LazyLoad;
}(React.Component));
exports.default = LazyLoad;


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ReactDOM = __webpack_require__(24);
var scroll_parent_1 = __webpack_require__(70);
// tslint:disable-next-line:no-any
exports.checkOverflowVisible = function (component, parent) {
    var node = ReactDOM.findDOMNode(component);
    if (!node) {
        return false;
    }
    var _a = parent.getBoundingClientRect(), parentTop = _a.top, parentHeight = _a.height;
    var windowInnerHeight = window.innerHeight || document.documentElement.clientHeight;
    // calculate top and height of the intersection of the element's scrollParent and viewport
    var intersectionTop = Math.max(parentTop, 0); // intersection's top relative to viewport
    var intersectionHeight = Math.min(windowInnerHeight, parentTop + parentHeight) - intersectionTop; // height
    // check whether the element is visible in the intersection
    var _b = node.getBoundingClientRect(), top = _b.top, height = _b.height;
    var offsetTop = top - intersectionTop; // element's top relative to intersection
    return (offsetTop - (component.props.offset || 0) <= intersectionHeight) &&
        (offsetTop + height + (component.props.offset || 0) >= 0);
};
// tslint:disable-next-line:no-any
exports.checkNormalVisible = function (component) {
    var node = ReactDOM.findDOMNode(component);
    if (!node) {
        return null;
    }
    var _a = node.getBoundingClientRect(), top = _a.top, elementHeight = _a.height;
    var windowInnerHeight = window.innerHeight || document.documentElement.clientHeight;
    return (top - (component.props.offset || 0) <= windowInnerHeight) &&
        (top + elementHeight + (component.props.offset || 0) >= 0);
};
// tslint:disable-next-line:no-any
exports.checkVisible = function (component) {
    var node = ReactDOM.findDOMNode(component);
    if (!node) {
        return false;
    }
    var parent = scroll_parent_1.scrollParent(node);
    var isOverflow = parent !== node.ownerDocument &&
        parent !== document &&
        parent !== document.documentElement;
    var visible = isOverflow ?
        exports.checkOverflowVisible(component, parent) :
        exports.checkNormalVisible(component);
    if (visible) {
        if (!component.visible) {
            component.visible = true;
            component.forceUpdate();
            return true;
        }
    }
    else if (component.visible) {
        component.visible = false;
    }
    return false;
};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.scrollParent = function (node) {
    if (!node) {
        return document;
    }
    var excludeStaticParent = node.style.position === 'absolute';
    var overflowRegex = /(scroll|auto)/;
    var parent = node;
    while (parent) {
        if (!parent.parentNode) {
            return node.ownerDocument || document;
        }
        var style = window.getComputedStyle(parent);
        var position = style.position;
        var overflow = style.overflow;
        var overflowX = style.getPropertyValue('overflow-x');
        var overflowY = style.getPropertyValue('overflow-y');
        if (position === 'static' && excludeStaticParent) {
            continue;
        }
        if (overflowRegex.test(overflow + overflowX + overflowY)) {
            return parent;
        }
        parent = parent.parentNode;
    }
    // tslint:disable-next-line:no-any
    return node.ownerDocument || node.documentElement || document;
};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(1);
var React = __webpack_require__(0);
var utils_1 = __webpack_require__(2);
var style_1 = __webpack_require__(3);
var buttonLink_1 = __webpack_require__(7);
var Link = /** @class */ (function (_super) {
    tslib_1.__extends(Link, _super);
    function Link() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Link.prototype.render = function () {
        var _a = this.props, children = _a.children, href = _a.href, linkStyle = _a.linkStyle, onClick = _a.onClick, target = _a.target, title = _a.title;
        return (React.createElement("a", tslib_1.__assign({}, utils_1.mergeStyles(buttonLink_1.getStyles(this.props), linkStyle), { onClick: onClick, href: href, title: title, target: target }), children));
    };
    Link.defaultProps = {
        size: style_1.VisualSize.SMALL,
        theme: buttonLink_1.LinkTheme.BLUE,
    };
    return Link;
}(React.Component));
exports.default = Link;


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(1);
var React = __webpack_require__(0);
var utils_1 = __webpack_require__(2);
var styles = __webpack_require__(73);
var ListLinksCollapsed = /** @class */ (function (_super) {
    tslib_1.__extends(ListLinksCollapsed, _super);
    function ListLinksCollapsed() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            opened: false,
        };
        _this.renderItem = function (item) {
            return (React.createElement("li", { key: item.id, className: styles['item'] },
                React.createElement("a", { href: item.url, className: styles['itemInner'], onClick: _this.props.linkOnClick }, item.title)));
        };
        _this.toggleList = function (e) {
            if (_this.props.toggleButtonClick) {
                _this.props.toggleButtonClick(e);
            }
            _this.setState({
                opened: !_this.state.opened,
            });
        };
        return _this;
    }
    ListLinksCollapsed.prototype.render = function () {
        var _a = this.props, links = _a.links, visibleCount = _a.visibleCount, openButtonText = _a.openButtonText, closeButtonText = _a.closeButtonText;
        var opened = this.state.opened;
        var resultLinks = links.filter(function (link) {
            return (!!link && (Object.keys(link).length > 0));
        });
        var isManyLinks = resultLinks.length > Number(visibleCount);
        resultLinks = opened || !isManyLinks ? resultLinks : resultLinks.slice(0, visibleCount);
        return (React.createElement("ul", { className: styles['list'] },
            resultLinks.map(this.renderItem),
            isManyLinks &&
                React.createElement("li", { className: styles['item'] },
                    React.createElement("button", tslib_1.__assign({}, utils_1.mergeStyles(styles['itemInner'], styles['more'], opened && styles['opened']), { type: "button", onClick: this.toggleList }), opened ? closeButtonText : openButtonText))));
    };
    ListLinksCollapsed.defaultProps = {
        visibleCount: 5,
        openButtonText: 'Показать все',
        closeButtonText: 'Скрыть',
    };
    return ListLinksCollapsed;
}(React.Component));
exports.default = ListLinksCollapsed;


/***/ }),
/* 73 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"list":"components-list-c23HtgZRII6","item":"components-item-c0Tk3q0b5Yi","itemInner":"components-itemInner-4cfGwhUW0wQ","more":"components-more-57Opsic9nik","opened":"components-opened-igzu0cZdG8k"};

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(1);
var React = __webpack_require__(0);
var button_1 = __webpack_require__(8);
var text_field_1 = __webpack_require__(4);
var buttonLink_1 = __webpack_require__(7);
var popup_1 = __webpack_require__(5);
var utils_1 = __webpack_require__(2);
var util_1 = __webpack_require__(14);
var util_2 = __webpack_require__(14);
var styles = __webpack_require__(75);
var util_3 = __webpack_require__(14);
exports.escapeKeyCode = 27;
var LocationSwitcher = /** @class */ (function (_super) {
    tslib_1.__extends(LocationSwitcher, _super);
    // private excludedRegions: IRegion[];
    function LocationSwitcher(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClearTextField = function () {
            _this.setState({
                search: '',
            });
        };
        _this.onValueChange = function (value) {
            _this.setState({
                search: value,
            });
        };
        _this.onLocationChange = function () {
            _this.setState({
                currentLocation: _this.state.selectedRegion || _this.state.currentLocation,
            });
            _this.props.onLocationChange(_this.state.selectedRegion || _this.state.currentLocation);
        };
        // this.excludedRegions = [] as IRegion[];
        if (props.currentLocation.id === util_3.FavoriteRegions.Moscow ||
            props.currentLocation.id === util_3.FavoriteRegions.MO) {
            props.currentLocation.displayName = util_3.MOSCOW_MO;
        }
        if (props.currentLocation.id === util_3.FavoriteRegions.SPB ||
            props.currentLocation.id === util_3.FavoriteRegions.LO) {
            props.currentLocation.displayName = util_3.SPB_LO;
        }
        var regionsViewModel = util_2.convertToViewModel(props.regions);
        if (props.expandedFavoritesRegions && props.expandedFavoritesRegions.length) {
            regionsViewModel.favorites = props.expandedFavoritesRegions.concat(regionsViewModel.favorites || []);
        }
        _this.state = {
            currentLocation: props.currentLocation,
            search: '',
            regionsViewModel: regionsViewModel,
        };
        document.addEventListener('keydown', function (event) { return _this.onKeyPress(event); }, false);
        return _this;
    }
    LocationSwitcher.prototype.render = function () {
        var _this = this;
        var regionsViewModel = this.state.regionsViewModel;
        if (!regionsViewModel) {
            regionsViewModel = {
                alphabet: [],
                favorites: [],
            };
        }
        if (!regionsViewModel.alphabet) {
            regionsViewModel.alphabet = [];
        }
        if (!regionsViewModel.favorites) {
            regionsViewModel.favorites = [];
        }
        var filteredRegions = util_1.filterRegions(regionsViewModel.alphabet, this.state.search);
        var regions = util_2.default(filteredRegions, new util_2.SeparatorProps(this.props.popupColumnsCount));
        var favorites = regionsViewModel.favorites.map(function (region) { return _this.mapRegion(region); });
        var alphabet = this.renderAlphabet(regions);
        return (React.createElement("div", tslib_1.__assign({}, utils_1.mergeStyles(styles['location_container'], this.props.isAdaptive && styles['location_container--adaptive'], this.props.containerStyles)), this.props.isPopupOpen &&
            React.createElement("div", { onClick: function () { return _this.props.onCloseButtonClick(); }, className: styles['location-select_layout'] },
                React.createElement("div", tslib_1.__assign({}, utils_1.mergeStyles(styles['location-select_container_wrapper'], this.props.popupStyle)),
                    React.createElement(popup_1.default, { containerStyle: styles['location-select_container'] },
                        React.createElement("div", { className: styles['select_container--boxing'], onClick: function (e) { return e.stopPropagation(); } },
                            React.createElement("div", { className: styles['select_container-header'] },
                                React.createElement("div", { className: styles['select_container-title'] }, "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0440\u0435\u0433\u0438\u043E\u043D"),
                                React.createElement("div", { className: styles['select_container-text_container'] },
                                    React.createElement("div", tslib_1.__assign({ onClick: this.handleClearTextField }, utils_1.mergeStyles(styles['select_container-text_clear'], this.state.search && styles['select_container-text_clear--active']))),
                                    React.createElement(text_field_1.default, { placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0440\u0435\u0433\u0438\u043E\u043D", inputStyle: styles['select_container-text_filed'], value: this.state.search || '', onValueChange: function (value) { return _this.onValueChange(value); } })),
                                React.createElement("div", { className: styles['select_container-country'] },
                                    React.createElement("span", null, "\u0420\u043E\u0441\u0441\u0438\u044F"))),
                            React.createElement("div", { className: styles['select_container-content'] },
                                React.createElement("div", { className: styles['select_container-alphabet'] },
                                    React.createElement("div", { className: styles['select_container-favorites'] }, favorites),
                                    React.createElement("div", { className: styles['select_container-alphabet_container'] }, alphabet))),
                            React.createElement("div", { className: styles['select_container-actions'] },
                                React.createElement(button_1.default, { theme: buttonLink_1.ButtonTheme.BLUE_SOLID, onClick: function () { return _this.onLocationChange(); }, buttonStyle: styles['select_container-save_button'] }, "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C")),
                            React.createElement("a", { onClick: function () { return _this.props.onCloseButtonClick(); }, className: styles['select_container-close'] })))))));
    };
    LocationSwitcher.prototype.renderAlphabet = function (regions) {
        var _this = this;
        return regions.map(function (column) {
            var columns = column.map(function (group) {
                var items = group[1].map(function (region) {
                    return (React.createElement("div", { className: styles['select_container-alphabet_item'] }, _this.mapRegion(region)));
                });
                return (React.createElement("div", { className: styles['select_container-alphabet_group'] },
                    React.createElement("span", null, group[0]),
                    React.createElement("div", { className: styles['select_container-alphabet_content'] }, items)));
            });
            return (React.createElement("div", { className: styles['select_container-alphabet_column'] }, columns));
        });
    };
    LocationSwitcher.prototype.mapRegion = function (region) {
        var _this = this;
        return (React.createElement("a", { onClick: function () { return _this.setState({
                currentLocation: _this.state.currentLocation,
                selectedRegion: region,
            }); }, className: region.id === (this.state.selectedRegion ? this.state.selectedRegion.id : this.state.currentLocation.id) ?
                styles['select_container-alphabet_item_link--selected'] : '' }, region.displayName));
    };
    LocationSwitcher.prototype.onKeyPress = function (event) {
        if (event.keyCode === exports.escapeKeyCode && this.props.isPopupOpen) {
            this.props.onCloseButtonClick();
        }
    };
    return LocationSwitcher;
}(React.Component));
exports.default = LocationSwitcher;


/***/ }),
/* 75 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"location_container":"components-location_container-cQzg24Z1rUi","location_ico-arrow":"components-location_ico-arrow-1ZIXrBp0LaA","location-select_layout":"components-location-select_layout-9ckhfODNTy8","location-select_container_wrapper":"components-location-select_container_wrapper-1RsLJAS4OIg","location-select_container":"components-location-select_container-5hB2qBRRdY6","select_container-title":"components-select_container-title-28cUCARn3Wi","select_container-text_container":"components-select_container-text_container-5rx2H6NXLas","select_container-text_clear":"components-select_container-text_clear-7SZY3wnxL2k","select_container-text_clear--active":"components-select_container-text_clear--active-5Rqf1zjqFia","select_container-text_filed":"components-select_container-text_filed-1LS2nWDUaUo","select_container-close":"components-select_container-close-1bro1Hp0Kwo","select_container-content":"components-select_container-content-dwwOZ9Lm92S","select_container-header":"components-select_container-header-iFymX7xB1C8","select_container-country":"components-select_container-country-bSjkNPoLksC","select_container-favorites":"components-select_container-favorites-BgLaTeRZxQ","select_container-alphabet_item_link--selected":"components-select_container-alphabet_item_link--selected-bNY5KZbP3yU","select_container--boxing":"components-select_container--boxing-6k6xSCMf4I","select_container-alphabet_container":"components-select_container-alphabet_container-bdcx8DKhP2I","select_container-alphabet":"components-select_container-alphabet-8ySvLwr4bes","select_container-alphabet--clear":"components-select_container-alphabet--clear-dlfq6Ajh84i","select_container-alphabet_group":"components-select_container-alphabet_group-ldVj2RH6Ssk","select_container-alphabet_column":"components-select_container-alphabet_column-bVL71XqNpK0","select_container-alphabet_content":"components-select_container-alphabet_content-9PVVJqI7pSc","select_container-alphabet_item":"components-select_container-alphabet_item-hPOULdK1dQU","select_container-alphabet_item_link":"components-select_container-alphabet_item_link-bHE6nPf79u","select_container-actions":"components-select_container-actions-8fFZYfUg1yw","select_container-save_button":"components-select_container-save_button-c8bXQYDKUgE","location_container--adaptive":"components-location_container--adaptive-lJH2HWBlYc0"};

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(1);
var React = __webpack_require__(0);
var utils_1 = __webpack_require__(2);
var events_1 = __webpack_require__(6);
var styles = __webpack_require__(77);
var MultilineTextField = /** @class */ (function (_super) {
    tslib_1.__extends(MultilineTextField, _super);
    function MultilineTextField() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.textArea = null;
        return _this;
    }
    MultilineTextField.prototype.componentDidMount = function () {
        // Trigger scroll check
        this.forceUpdate();
    };
    MultilineTextField.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.value !== prevProps.value) {
            // Trigger scroll check
            this.forceUpdate();
        }
    };
    MultilineTextField.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", tslib_1.__assign({}, utils_1.mergeStyles(styles['container'], this.props.required && styles['required'], this.props.containerStyle)),
            React.createElement("textarea", tslib_1.__assign({ ref: function (textArea) { return _this.textArea = textArea; } }, utils_1.mergeStyles(styles['input'], this.props.invalid && styles['invalid'], this.props.inputStyle), { rows: this.calculateRowsCount(), disabled: this.props.disabled, placeholder: this.props.placeholder, value: this.props.value, onChange: events_1.createInputChangeHandler(this.props.onValueChange), name: this.props.name })),
            this.isTextLengthVisible() &&
                React.createElement("span", tslib_1.__assign({}, utils_1.mergeStyles(styles['text_length'], this.props.disabled && styles['text_length-disabled'], this.hasScroll() && styles['text_length-scroll'], this.calculateTextLength() < 0 && styles['invalid'], this.props.lengthStyle)), this.calculateTextLength())));
    };
    MultilineTextField.prototype.hasScroll = function () {
        if (!this.textArea) {
            return false;
        }
        return this.textArea.scrollHeight > this.textArea.clientHeight;
    };
    MultilineTextField.prototype.calculateRowsCount = function () {
        var rows = this.props.value.split('\n').length;
        return rows < this.props.minRows
            ? this.props.minRows
            : rows;
    };
    MultilineTextField.prototype.calculateTextLength = function () {
        return this.props.maxLength - this.props.value.length;
    };
    MultilineTextField.prototype.isTextLengthVisible = function () {
        return typeof this.props.maxLength === 'number';
    };
    MultilineTextField.defaultProps = {
        minRows: 1,
    };
    return MultilineTextField;
}(React.Component));
exports.default = MultilineTextField;


/***/ }),
/* 77 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"components-container-1ZSPnSDpH2I","input":"components-input-2PNZ9rPm4U4","required":"components-required-fGixvWRktiW","text_length":"components-text_length-k42aMJaEAEo","text_length-scroll":"components-text_length-scroll-8aUOeubDq0i","invalid":"components-invalid-fuJn7xFzKEK","text_length-disabled":"components-text_length-disabled-e5RjCOwrtKk"};

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(1);
var utils_1 = __webpack_require__(2);
var React = __webpack_require__(0);
var style_1 = __webpack_require__(3);
var styles = __webpack_require__(79);
var text_field_1 = __webpack_require__(4);
var PasswordField = /** @class */ (function (_super) {
    tslib_1.__extends(PasswordField, _super);
    function PasswordField() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.textField = null;
        _this.state = {
            hidden: true,
        };
        return _this;
    }
    PasswordField.prototype.focus = function () {
        if (this.textField) {
            this.textField.focus();
        }
    };
    PasswordField.prototype.blur = function () {
        if (this.textField) {
            this.textField.blur();
        }
    };
    PasswordField.prototype.render = function () {
        var _this = this;
        var size = this.props.size;
        return (React.createElement("div", tslib_1.__assign({}, utils_1.mergeStyles(styles['container'])),
            React.createElement(text_field_1.default, tslib_1.__assign({ type: this.state.hidden ? 'password' : 'text' }, this.props, { ref: function (textField) { return _this.textField = textField; } })),
            React.createElement("button", tslib_1.__assign({}, utils_1.mergeStyles(styles['eye'], size === style_1.VisualSize.SMALL && styles['eye-small'], size === style_1.VisualSize.MEDIUM && styles['eye-medium'], size === style_1.VisualSize.LARGE && styles['eye-large'], this.state.hidden ? styles['eye-closed'] : styles['eye-opened']), { type: "button", onClick: function () { return _this.setState({ hidden: !_this.state.hidden }); } }))));
    };
    PasswordField.defaultProps = {
        size: style_1.VisualSize.SMALL,
    };
    return PasswordField;
}(React.Component));
exports.default = PasswordField;


/***/ }),
/* 79 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"components-container-dFJuz66cXm6","eye":"components-eye-8Haz1vpYacy","eye-opened":"components-eye-opened-7iTcwk7Ukgk","eye-closed":"components-eye-closed-3vUhRaBq2cg","eye-small":"components-eye-small-4uMr669w36Q","eye-medium":"components-eye-medium-b7chFWHWp2A","eye-large":"components-eye-large-d1S5K8v59Qk"};

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(1);
var React = __webpack_require__(0);
var style_1 = __webpack_require__(3);
var styles = __webpack_require__(81);
var text_field_1 = __webpack_require__(4);
function normalizeNumber(phoneNumber) {
    var cleanedPhoneNumber = '';
    for (var i = 0; i < phoneNumber.length; i++) {
        var c = phoneNumber[i];
        if (c >= '0' && c <= '9') {
            cleanedPhoneNumber += c;
        }
    }
    return cleanedPhoneNumber;
}
function halfNormalizeNumber(phoneNumber) {
    var cleanedPhoneNumber = '';
    for (var i = 0; i < phoneNumber.length; i++) {
        var c = phoneNumber[i];
        if ((c >= '0' && c <= '9') || c === '(' || c === ')' || c === ' ' || c === '-' || (c === '+' && i === 0)) {
            cleanedPhoneNumber += c;
        }
    }
    return cleanedPhoneNumber;
}
function isInvalid(mobile, value) {
    return !!(value
        && value.length > 0
        && ((mobile && value[0] !== '7')
            || (mobile && value.length > 11)
            || (!mobile && value.length > 15)
            || (normalizeNumber(value) !== value)));
}
var PhoneField = /** @class */ (function (_super) {
    tslib_1.__extends(PhoneField, _super);
    function PhoneField() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.textField = null;
        _this.state = {
            phoneNumber: '',
        };
        return _this;
    }
    PhoneField.prototype.focus = function () {
        if (this.textField) {
            this.textField.focus();
        }
    };
    PhoneField.prototype.blur = function () {
        if (this.textField) {
            this.textField.blur();
        }
    };
    PhoneField.prototype.componentWillReceiveProps = function (nextProps) {
        if (isInvalid(!!nextProps.mobile, nextProps.value)) {
            this.setState({ phoneNumber: '' });
            nextProps.onValueChange('');
        }
        else {
            var normalizedRemote = normalizeNumber(nextProps.value || '');
            var normalizedLocal = normalizeNumber(this.state.phoneNumber);
            if (normalizedRemote !== normalizedLocal) {
                this.setState({
                    phoneNumber: normalizedRemote,
                });
            }
        }
    };
    PhoneField.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", tslib_1.__assign({}, style_1.mergeStyles(styles['container'], this.props.containerStyle)),
            this.props.mobile &&
                React.createElement("div", { className: styles['country_code'] }, "+7"),
            React.createElement("div", { className: styles['phone_number'] },
                React.createElement(text_field_1.default, tslib_1.__assign({}, this.props, { containerStyle: [], ref: function (textField) { return _this.textField = textField; }, type: "phone", mask: this.props.mobile
                        ? "999 999-99-99"
                        : undefined, value: this.props.mobile
                        ? this.state.phoneNumber.slice(1)
                        : this.state.phoneNumber, onValueChange: function (value) { return _this.handlePhoneChange(value); } })))));
    };
    PhoneField.prototype.handlePhoneChange = function (phoneNumber) {
        var _this = this;
        var normalizedNumber = this.props.mobile
            ? "7" + normalizeNumber(phoneNumber)
            : normalizeNumber(phoneNumber);
        if (isInvalid(!!this.props.mobile, normalizedNumber)) {
            return;
        }
        if (this.props.mobile) {
            this.setState({
                phoneNumber: normalizedNumber,
            }, function () {
                _this.props.onValueChange(normalizedNumber);
            });
        }
        else {
            this.setState({
                phoneNumber: halfNormalizeNumber(phoneNumber),
            }, function () {
                _this.props.onValueChange(normalizedNumber);
            });
        }
    };
    return PhoneField;
}(React.Component));
exports.default = PhoneField;


/***/ }),
/* 81 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"components-container-7fG39h8yXek","country_code":"components-country_code-fatNNLh8cg2","phone_number":"components-phone_number-dQfLCQkb1Qo"};

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(1);
var React = __webpack_require__(0);
var utils_1 = __webpack_require__(2);
var styles = __webpack_require__(83);
var PopupMobile = /** @class */ (function (_super) {
    tslib_1.__extends(PopupMobile, _super);
    function PopupMobile() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleContentClick = function (e) {
            e.stopPropagation();
        };
        _this.handleTogglePopup = function () {
            if (_this.props.onToggle) {
                _this.props.onToggle(_this.props.opened);
            }
        };
        return _this;
    }
    PopupMobile.prototype.render = function () {
        var haveButtons = !!this.props.buttons.length;
        return (React.createElement("div", tslib_1.__assign({}, utils_1.mergeStyles(styles['container'], this.props.opened && styles['opened'], this.props.containerStyle), { onClick: this.handleTogglePopup }),
            React.createElement("div", tslib_1.__assign({}, utils_1.mergeStyles(styles['inner'], this.props.opened && styles['opened'], this.props.innerStyle), { onClick: this.handleContentClick }),
                React.createElement("div", tslib_1.__assign({}, utils_1.mergeStyles(styles['content'], haveButtons && styles['shadow'], !haveButtons && styles['circled'], this.props.contentStyle)), this.props.children),
                React.createElement("div", tslib_1.__assign({}, utils_1.mergeStyles(styles['buttons'], this.props.buttonsStyle)), haveButtons && this.props.buttons.map(function (button) { return React.createElement("button", { className: styles['button'], type: button.type || 'button', onClick: button.onClick }, button.text); })))));
    };
    PopupMobile.defaultProps = {
        opened: false,
        buttons: [],
    };
    return PopupMobile;
}(React.Component));
exports.default = PopupMobile;


/***/ }),
/* 83 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"components-container-3nudaNeQAwk","inner":"components-inner-4TN9rJhpUkq","content":"components-content-i7OJtv2Bziq","buttons":"components-buttons-h6CuzF70dyG","button":"components-button-ccewPXImoEk","opened":"components-opened-2t0NIVMeUYA","circled":"components-circled-gBGlIPUSMo","shadow":"components-shadow-a8GrtZpJ5ui"};

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(1);
var React = __webpack_require__(0);
var react_1 = __webpack_require__(0);
var utils_1 = __webpack_require__(2);
var styles = __webpack_require__(85);
var Preloader = /** @class */ (function (_super) {
    tslib_1.__extends(Preloader, _super);
    function Preloader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Preloader.prototype.render = function () {
        var size = this.props.size;
        var preloaderDefaultStyle = {
            width: size,
            height: size,
        };
        return (React.createElement("svg", tslib_1.__assign({}, utils_1.mergeStyles(styles['preloader'], preloaderDefaultStyle, this.props.preloaderStyle), { viewBox: "0 0 40 40" }),
            React.createElement("defs", null,
                React.createElement("linearGradient", { id: "preloader-gradient", gradientUnits: "userSpaceOnUse", y1: "30", x2: "40", y2: "30" },
                    React.createElement("stop", { offset: "0", stopColor: "#0076eb" }),
                    React.createElement("stop", { offset: "1", stopColor: "#fff", stopOpacity: "0" }))),
            React.createElement("path", { fill: "url(#preloader-gradient)", d: "M20,35c-8.3,0-15-6.7-15-15H0c0,11,9,20,20,20c11,0,20-9,20-20h-5C35,28.3,28.3,35,20,35z" })));
    };
    Preloader.defaultProps = {
        size: 16,
    };
    return Preloader;
}(react_1.Component));
exports.default = Preloader;


/***/ }),
/* 85 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"preloader":"components-preloader-6VDMNEK05UU","spin":"components-spin-hNcVJGAqaI2"};

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(1);
var React = __webpack_require__(0);
var utils_1 = __webpack_require__(2);
var styles = __webpack_require__(87);
var RadioGroupField = /** @class */ (function (_super) {
    tslib_1.__extends(RadioGroupField, _super);
    function RadioGroupField() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RadioGroupField.prototype.render = function () {
        var _this = this;
        return (React.createElement("span", tslib_1.__assign({}, utils_1.mergeStyles(styles['container'], !!this.props.inline && styles['inline'], !this.props.inline && styles['block'], this.props.containerStyle)), this.props.values.map(function (value) { return (React.createElement("span", { key: value.value, className: styles['value'] },
            React.createElement("label", tslib_1.__assign({}, utils_1.mergeStyles(styles['label'], _this.props.value === value.value && styles['label-active']), { onClick: function () { return _this.props.onValueChange(value.value); } }), value.label))); })));
    };
    return RadioGroupField;
}(React.Component));
exports.default = RadioGroupField;


/***/ }),
/* 87 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"components-container-hHREhDLF5ek","label":"components-label-bwyWWX0pKEE","label-active":"components-label-active-jprOm6ohKom","block":"components-block-4MyUsYFkzKu","value":"components-value-8umvvePpnOA","inline":"components-inline-k4jy0Pc2kgc"};

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(1);
var React = __webpack_require__(0);
var utils_1 = __webpack_require__(2);
var styles = __webpack_require__(89);
var number_field_1 = __webpack_require__(25);
var tooltip_1 = __webpack_require__(27);
var RangeInputGroup = /** @class */ (function (_super) {
    tslib_1.__extends(RangeInputGroup, _super);
    function RangeInputGroup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.minNumberField = null;
        _this.maxNumberField = null;
        _this.state = {};
        _this.renderField = function (options) {
            return (React.createElement(number_field_1.default, tslib_1.__assign({ ref: function (numberField) {
                    if (options.type === 'min') {
                        _this.minNumberField = numberField;
                    }
                    else {
                        _this.maxNumberField = numberField;
                    }
                } }, options, { disablePrettyFormating: options.disablePrettyFormating, type: options.inputType, containerStyle: [
                    styles['container'],
                    _this.state.focused === options.type && styles['focused'],
                    options.error && styles['error'],
                ], inputStyle: [styles['input'], options.inputStyle] })));
        };
        _this.handleFocus = function (id) {
            // tslint:disable-next-line:no-any
            var fieldProps = _this.props[id];
            if (fieldProps.onFocus) {
                fieldProps.onFocus();
            }
            _this.setState({
                focused: id,
            });
        };
        _this.handleBlur = function (id) {
            // tslint:disable-next-line:no-any
            var fieldProps = _this.props[id];
            if (fieldProps.onBlur) {
                fieldProps.onBlur();
            }
            _this.setState({
                focused: undefined,
            });
        };
        _this.handleChange = function (id, value) {
            // tslint:disable-next-line:no-any
            var fieldProps = _this.props[id];
            if (fieldProps.onValueChange) {
                fieldProps.onValueChange(value);
            }
        };
        _this.wrapWithTooltip = function (node, errorText, common) {
            var errorTextCommon = _this.props.errorTextCommon;
            if (!errorText) {
                errorText = 'Неверное значение';
            }
            return (React.createElement(tooltip_1.default, { arrow: false, thin: true, multiline: true, tooltipContent: common ? errorTextCommon : errorText, tooltipStyles: [
                    styles['tooltip'],
                    common && styles['wide'],
                ], position: 2 }, node));
        };
        _this.handleFocusMin = function () { return _this.handleFocus('min'); };
        _this.handleFocusMax = function () { return _this.handleFocus('max'); };
        _this.handleBlurMin = function () { return _this.handleBlur('min'); };
        _this.handleBlurMax = function () { return _this.handleBlur('max'); };
        _this.handleChangeMin = function (value) { return _this.handleChange('min', value); };
        _this.handleChangeMax = function (value) { return _this.handleChange('max', value); };
        return _this;
    }
    RangeInputGroup.prototype.focusMinField = function () {
        if (this.minNumberField) {
            this.minNumberField.focus();
        }
    };
    RangeInputGroup.prototype.focusMaxField = function () {
        if (this.maxNumberField) {
            this.maxNumberField.focus();
        }
    };
    RangeInputGroup.prototype.render = function () {
        var _a = this.props, min = _a.min, max = _a.max, rangeGroupStyle = _a.rangeGroupStyle;
        var rangeGroupStyles = utils_1.mergeStyles(styles['rangeGroup'], rangeGroupStyle);
        var minField = this.renderField(Object.assign({}, min, {
            type: 'min',
            onFocus: this.handleFocusMin,
            onBlur: this.handleBlurMin,
            onValueChange: this.handleChangeMin,
        }));
        var maxField = this.renderField(Object.assign({}, max, {
            type: 'max',
            onFocus: this.handleFocusMax,
            onBlur: this.handleBlurMax,
            onValueChange: this.handleChangeMax,
        }));
        // if both fields with errors - wrap whole block with tooltip
        if (min.error && max.error) {
            var content = React.createElement("div", tslib_1.__assign({}, rangeGroupStyles),
                minField,
                maxField);
            return this.wrapWithTooltip(content, null, true);
        }
        // otherwise wrap one of the fields
        minField = min.error ? this.wrapWithTooltip(minField, min.errorText) : minField;
        maxField = max.error ? this.wrapWithTooltip(maxField, max.errorText) : maxField;
        return (React.createElement("div", tslib_1.__assign({}, rangeGroupStyles),
            minField,
            maxField));
    };
    RangeInputGroup.defaultProps = {
        min: {},
        max: {},
        errorTextCommon: 'Неверные значения',
    };
    return RangeInputGroup;
}(React.Component));
exports.default = RangeInputGroup;


/***/ }),
/* 89 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"rangeGroup":"components-rangeGroup-wGF1GHiX84","container":"components-container-eOCO7RcK3Yg","input":"components-input-hDQwuF96SIY","tooltip":"components-tooltip-9pbBd6CFJSg","wide":"components-wide-aHjRMSk6g8o","focused":"components-focused-h1DMaJhIOc6","error":"components-error-jC18pw3AjeC"};

/***/ }),
/* 90 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"components-container-fTc4SlYSiWY","block":"components-block-4dFPuykgVaM","text_size_calculator":"components-text_size_calculator-1K6bg3k5XeW","wrapper":"components-wrapper-Q7C3jRoESq","thin":"components-thin-cBiVb2P8vm2","wide":"components-wide-3UZVW9SglOe","arrow":"components-arrow-aAbqXBIfgAs","content":"components-content-bi5kmHOfwA0","multiline":"components-multiline-ir02WlSacgK","bottom_right":"components-bottom_right-iNkRnDMlAAC","bottom_wide":"components-bottom_wide-rTn4Lnjdp6","bottom_left":"components-bottom_left-9AlQW80cmsQ","right_center":"components-right_center-1jaEmlUy7QW","top_left":"components-top_left-dnstBH1NGEm","top_right":"components-top_right-5odXt9IPzUw"};

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(1);
var React = __webpack_require__(0);
var utils_1 = __webpack_require__(2);
var react_1 = __webpack_require__(0);
var styles = __webpack_require__(92);
var Tag = /** @class */ (function (_super) {
    tslib_1.__extends(Tag, _super);
    function Tag() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Tag.prototype.render = function () {
        var _a = this.props, tagStyles = _a.tagStyles, children = _a.children, onClick = _a.onClick;
        return (React.createElement("div", tslib_1.__assign({}, utils_1.mergeStyles(styles['tag'], tagStyles), { onClick: onClick }),
            children,
            React.createElement("button", { className: styles['button'], type: "button", onClick: this.props.onDeleteClick })));
    };
    return Tag;
}(react_1.Component));
exports.default = Tag;


/***/ }),
/* 92 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"tag":"components-tag-hPvYAzYeQ0M","button":"components-button-cfascFiZAk4"};

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(1);
var React = __webpack_require__(0);
var utils_1 = __webpack_require__(2);
var styles = __webpack_require__(94);
var TabGroup = /** @class */ (function (_super) {
    tslib_1.__extends(TabGroup, _super);
    function TabGroup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TabGroup.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", tslib_1.__assign({}, utils_1.mergeStyles(styles['container'], this.props.containerStyle)), this.props.tabs.map(function (tab) { return (React.createElement("button", tslib_1.__assign({ key: tab.id }, utils_1.mergeStyles(styles['tab'], tab.id === _this.props.activeTab
            ? styles['tab-active']
            : styles['tab-inactive'], _this.props.tabStyle, tab.id === _this.props.activeTab
            ? _this.props.activeTabStyle
            : _this.props.inactiveTabStyle, tab.disabled
            && styles['tab-disabled'], tab.disabled
            && _this.props.disabledTabStyle), { type: "button", onClick: function () { return !tab.disabled && _this.props.onTabClick(tab.id); } }), tab.title)); })));
    };
    return TabGroup;
}(React.Component));
exports.default = TabGroup;


/***/ }),
/* 94 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"components-container-lHkjWDPgqse","tab":"components-tab-iYnqPe0sCsO","tab-active":"components-tab-active-7o50cjvFLiA","tab-inactive":"components-tab-inactive-7Ot90yf6lUo","tab-disabled":"components-tab-disabled-Wu4YtNpfcQ"};

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(1);
var React = __webpack_require__(0);
var style_1 = __webpack_require__(3);
var styles = __webpack_require__(96);
var VerticalCard = /** @class */ (function (_super) {
    tslib_1.__extends(VerticalCard, _super);
    function VerticalCard() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VerticalCard.prototype.render = function () {
        var _a = this.props, media = _a.media, content = _a.content, banner = _a.banner;
        return (React.createElement("div", tslib_1.__assign({}, style_1.mergeStyles(styles['vertical_card_container'])),
            React.createElement("div", tslib_1.__assign({}, style_1.mergeStyles(styles['vertical_card_layout'])),
                React.createElement("div", tslib_1.__assign({}, style_1.mergeStyles(styles['vertical_card_layout-media'])),
                    media,
                    banner &&
                        React.createElement("div", tslib_1.__assign({}, style_1.mergeStyles(styles['vertical_card_layout-media_banner'])), banner)),
                React.createElement("div", tslib_1.__assign({}, style_1.mergeStyles(styles['vertical_card_layout-content'])), content))));
    };
    return VerticalCard;
}(React.Component));
exports.default = VerticalCard;


/***/ }),
/* 96 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"vertical_card_container":"components-vertical_card_container-goKun7rT3Mc","vertical_card_layout":"components-vertical_card_layout-h1CL4X87baC","vertical_card_layout-media":"components-vertical_card_layout-media-jRfmScgH96A","vertical_card_layout-media_banner":"components-vertical_card_layout-media_banner-gBhL1iIHF6S","vertical_card_layout-content":"components-vertical_card_layout-content-6mQs3hPMhG2"};

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(1);
var React = __webpack_require__(0);
var utils_1 = __webpack_require__(2);
var styles = __webpack_require__(98);
var VerticalCardExtended = /** @class */ (function (_super) {
    tslib_1.__extends(VerticalCardExtended, _super);
    function VerticalCardExtended() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VerticalCardExtended.prototype.render = function () {
        var _a = this.props, media = _a.media, content = _a.content, banner = _a.banner, footer = _a.footer;
        return (React.createElement("div", { className: styles['vertical_card_extended_container'] },
            React.createElement("div", { className: styles['vertical_card_extended_layout'] },
                React.createElement("div", { className: styles['vertical_card_extended_layout-media'] },
                    media,
                    banner &&
                        React.createElement("div", { className: styles['vertical_card_layout-media_banner'] }, banner)),
                React.createElement("div", { className: styles['vertical_card_extended_layout-content'] }, content),
                React.createElement("div", tslib_1.__assign({}, utils_1.mergeStyles(styles['vertical_card_extended_layout-footer'], this.props.customFooterStyles)), footer))));
    };
    return VerticalCardExtended;
}(React.Component));
exports.default = VerticalCardExtended;


/***/ }),
/* 98 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"vertical_card_extended_container":"components-vertical_card_extended_container-1aJun9vyUk6","vertical_card_extended_layout":"components-vertical_card_extended_layout-1RHq33Ozwwq","vertical_card_extended_layout-media":"components-vertical_card_extended_layout-media-ksJfGUkXUAC","vertical_card_extended_layout-media_banner":"components-vertical_card_extended_layout-media_banner-7rJRpTzhBuA","vertical_card_extended_layout-content":"components-vertical_card_extended_layout-content-jGhV0QBGA8y","vertical_card_extended_layout-footer":"components-vertical_card_extended_layout-footer-9ZwouY1Cyke"};

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(1);
var React = __webpack_require__(0);
var style_1 = __webpack_require__(3);
var popup_1 = __webpack_require__(5);
var styles = __webpack_require__(100);
var Modal = /** @class */ (function (_super) {
    tslib_1.__extends(Modal, _super);
    function Modal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Modal.prototype.render = function () {
        return (React.createElement(popup_1.default, { containerStyle: style_1.mergeStyles(styles['modalContainer'], {
                width: this.props.width,
                minHeight: this.props.minHeight,
                minWidth: this.props.minWidth,
                maxHeight: this.props.maxHeight,
                maxWidth: this.props.maxWidth,
            }) },
            this.props.closeBtn,
            this.props.header &&
                React.createElement("div", tslib_1.__assign({}, style_1.mergeStyles(styles['modalContainer-header'], this.props.headerStyle)), this.props.header),
            React.createElement("div", tslib_1.__assign({}, style_1.mergeStyles(styles['modalContainer-content'], this.props.contentStyle)), this.props.children),
            this.props.footer &&
                React.createElement("div", tslib_1.__assign({}, style_1.mergeStyles(styles['modalContainer-footer'], this.props.footerStyle)), this.props.footer)));
    };
    return Modal;
}(React.Component));
exports.default = Modal;


/***/ }),
/* 100 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"modalContainer":"components-modalContainer-8cS74LiejKU","modalContainer-header":"components-modalContainer-header-7EXuvLnipiW","modalContainer-content":"components-modalContainer-content-5vvLswzgtyg","modalContainer-footer":"components-modalContainer-footer-kVD0FDw6Gcw"};

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(1);
var React = __webpack_require__(0);
var react_1 = __webpack_require__(0);
var style_1 = __webpack_require__(3);
var styles = __webpack_require__(102);
var ModalWrapper = /** @class */ (function (_super) {
    tslib_1.__extends(ModalWrapper, _super);
    function ModalWrapper() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.escHandler = function (event) {
            if (event.keyCode === 27 && _this.props.onClose) {
                _this.props.onClose();
            }
        };
        return _this;
    }
    ModalWrapper.prototype.componentDidMount = function () {
        document.addEventListener('keyup', this.escHandler);
        document.body.style.overflow = 'hidden';
    };
    ModalWrapper.prototype.componentWillUnmount = function () {
        document.removeEventListener('keyup', this.escHandler);
        document.body.style.overflow = 'auto';
    };
    ModalWrapper.prototype.render = function () {
        var _this = this;
        var containerStyle = this.props.containerStyle;
        return (React.createElement("div", tslib_1.__assign({}, style_1.mergeStyles(styles['container'], containerStyle)),
            React.createElement("div", { className: styles['wrapper'] },
                React.createElement("div", { className: styles['overlay'], onClick: function () { return _this.props.onClose && _this.props.onClose(); } }),
                this.props.children)));
    };
    ;
    return ModalWrapper;
}(react_1.Component));
exports.default = ModalWrapper;


/***/ }),
/* 102 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"components-container-22pN6tPihai","overlay":"components-overlay-cR309KJ8Bi0","wrapper":"components-wrapper-aZjTZRTd2o0"};

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(1);
var React = __webpack_require__(0);
var react_1 = __webpack_require__(0);
var styles = __webpack_require__(104);
var button_1 = __webpack_require__(8);
var style_1 = __webpack_require__(3);
var LocationOffer = /** @class */ (function (_super) {
    tslib_1.__extends(LocationOffer, _super);
    function LocationOffer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LocationOffer.prototype.render = function () {
        return (React.createElement("div", { className: styles['location_tooltip-container'] },
            React.createElement("div", { className: styles['location_tooltip-content'] },
                React.createElement("span", null,
                    React.createElement("svg", { className: styles['location_tooltip-geo_icon'], xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 9 14" },
                        React.createElement("path", { fill: "#2B87DB", fillRule: "evenodd", d: "M.55 6.987l3.7 6.84c.124.228.32.233.445 0l3.702-6.84.054-.113A4.854 4.854 0 0 0 9 4.727C9 2.77 7.85 1.013 6.11.313c-1.74-.7-3.713-.2-4.96 1.257C-.093 3.027-.354 5.14.496 6.883l.054.104zm3.95-4.34c.82 0 1.556.52 1.866 1.317.31.796.13 1.71-.454 2.312a1.945 1.945 0 0 1-2.21.435C2.952 6.37 2.47 5.59 2.484 4.73c.02-1.154.917-2.08 2.016-2.08z" })),
                    "\u0412\u0430\u0448 \u0440\u0435\u0433\u0438\u043E\u043D ",
                    this.props.currentLocation.displayName,
                    "?"),
                React.createElement(button_1.default, { buttonStyle: styles['location_tooltip-button'], size: style_1.VisualSize.SMALL, onClick: this.props.onAcceptLocation }, "\u0414\u0430, \u0432\u0441\u0451 \u0432\u0435\u0440\u043D\u043E"),
                React.createElement(button_1.default, { buttonStyle: styles['location_tooltip-button'], size: style_1.VisualSize.SMALL, onClick: this.props.onDeclineLocation }, "\u041D\u0435\u0442, \u0441\u043C\u0435\u043D\u0438\u0442\u044C \u0440\u0435\u0433\u0438\u043E\u043D"))));
    };
    return LocationOffer;
}(react_1.Component));
exports.default = LocationOffer;


/***/ }),
/* 104 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"location_tooltip-container":"components-location_tooltip-container-kv2MdZR9hQc","location_tooltip-content":"components-location_tooltip-content-7mrbsdVg9G6","location_tooltip-geo_icon":"components-location_tooltip-geo_icon-bZuVHw5CTYq","location_tooltip-button":"components-location_tooltip-button-4WuPbj2ONOQ"};

/***/ })
/******/ ]);
//# sourceMappingURL=frontend-components.js.map